
/* LMM catalog-wide guided search · Draft theme only · no catalog/S&D writes */
(function () {
  'use strict';

  var VERSION = '2026.08.14-catalog-4';
  if (window.LMMSearchIntent && window.LMMSearchIntent.version === VERSION) return;

  var FILTERS = {
    kelvin: 'filter.p.m.specs.kelvin',
    /* Lichtfarbcode als EIGENER Collection-Filter (Chris 2026-08-14). Auf den
       Collections ist specs.color_code eine gerenderte Facette mit
       entfernbarem Aktiv-Chip (lmm-collection-list, "Lichtfarbcode") und live
       als wirksam belegt: leuchtstoffroehren color_code=827 -> 3 Treffer
       (kelvin-Naeherung 2700+3000 zog 9 inkl. 830er herein), color_code=840
       -> 8 inkl. Rang-18-Artikel, gu10-led-lampen color_code=927 -> 16.
       NUR fuer Collection-Routen — die /search-Kandidatenstufe in
       lmm-tech-rank behaelt bewusst Kelvin, weil die SUCHSEITE fuer
       color_code keine Facette rendert (dort waere es eine heimliche
       Verengung). */
    code: 'filter.p.m.specs.color_code',
    base: 'filter.p.m.specs.base',
    dimmable: 'filter.p.m.specs.dimmable',
    length: 'filter.p.m.specs.length_mm',
    wattage: 'filter.p.m.specs.wattage',
    replaces: 'filter.p.m.specs.replaces_wattage',
    lumen: 'filter.p.m.specs.lumen',
    beam: 'filter.p.m.specs.beam_angle',
    energy: 'filter.p.m.specs.energy_class',
    ip: 'filter.p.m.specs.ip_rating',
    vendor: 'filter.p.vendor'
  };

  var GENERIC = new Set([
    'alle','all','kaufen','online','shop','von','und','oder','mit','fuer','fur','der','die','das','den','dem','des',
    'ein','eine','einer','einem','einen','nach','inkl','inklusive','passend','passende','auswahl','uebersicht',
    'komplett','komplette','artikel','produkte','produkt','markt','com','de'
  ]);
  var MODIFIER = new Set([
    'warmweiss','neutralweiss','kaltweiss','tageslicht','tageslichtweiss','extra','warm','weiss','daylight','cool',
    'white','interna','warmton','dimmbar','dimmbare','dimmbaren','dimmbarer','dimmbares','dimmable','dimmen','nicht','ersetzt','ersatz','statt','anstelle','entspricht','watt','lumen','lm','kelvin','grad','winkel',
    'v','volt','abstrahlwinkel','sofort','lieferbar','k','w','mm','cm','m','pin','4p','2p','meter','metre','ip','energieklasse','eek','he','ho'
  ]);
  var SERIES = new Set(['dulux','lumilux','substitube','haloline','decostar','halostar','halopin','parathom','mastercolour','powerball','xenophot','corepro','master','star','value','performance','classic','ralux','ledspot','tuv','actinic']);
  var BRANDS = [
    'osram','ledvance','philips','sylvania','modee','patron','evn','wago','varta','duracell','panasonic','radium',
    'abb','abl','busch jaeger','gira','jung','mennekes','nordic','houben','heidelberg','juice technology','legrand',
    'luceco','pracht','phoenix contact','seko systems','walther','paulmann','aurora','hera','tridonic'
  ];
  var KNOWN_BASES = [
    '2g10','2g11','2g7','b15','b15d','b22d','ba15d','e14','e27','e40','g4','g5','g9','g10q','g13','g23','g24d',
    'g24q','g53','gr8','gr10q','gu4','gu10','gu53','gx10','gx5.3','gx24d','gx24q','gy635','r7s','s14','s14d','s14s','s15s','s19s'
  ];
  var timer = 0;
  var catalog = [];
  var catalogByHandle = new Map();

  var FAMILY_RULES = [
    { id:'t8', bases:['t8','g13'], general:'t8-leuchtstoffroehren', led:'t8-led-roehren', fluorescent:'t8-leuchtstoffroehren', aliases:['t8','g13','26mm roehre'] },
    { id:'t5', bases:['t5','g5'], general:'t5-leuchtstoffroehren', led:'t5-led-roehren', fluorescent:'t5-leuchtstoffroehren', aliases:['t5','g5','16mm roehre'] },
    { id:'t9', bases:['t9','g10q'], general:'t9-ringform-roehren', led:'t9-led-roehren-ringform', fluorescent:'t9-ringform-roehren', aliases:['t9','g10q','ringroehre','ringform'] },
    { id:'gu10', bases:['gu10'], general:'gu10-leuchtmittel', led:'gu10-led-lampen', halogen:'gu10-halogenlampen', aliases:['gu10','par16'] },
    { id:'gu53', bases:['gu53'], general:'gu5-3-leuchtmittel', led:'gu5-3-led-leuchtmittel', halogen:'gu5-3-halogenlampen', aliases:['gu53','mr16'] },
    { id:'gu4', bases:['gu4'], general:'gu4-leuchtmittel', led:'gu4-led-leuchtmittel', halogen:'gu4-halogenlampen', aliases:['gu4','mr11'] },
    { id:'g53', bases:['g53'], general:'g53-leuchtmittel', led:'g53-led-leuchtmittel', halogen:'g53-halogenlampen', aliases:['g53','ar111'] },
    { id:'g4', bases:['g4'], general:'g4-leuchtmittel', led:'g4-led-leuchtmittel', halogen:'g4-halogenlampen', aliases:['g4'] },
    { id:'g9', bases:['g9'], general:'g9-leuchtmittel', led:'g9-led-leuchtmittel', halogen:'g9-halogenlampen', aliases:['g9','halopin'] },
    { id:'gy635', bases:['gy635'], general:'gy6-35-leuchtmittel', led:'gy6-35-led-leuchtmittel', halogen:'gy6-35-halogenlampen', aliases:['gy635','g635'] },
    { id:'r7s', bases:['r7s'], general:'r7s-leuchtmittel', led:'r7s-led-leuchtmittel', halogen:'r7s-halogenlampen', aliases:['r7s','halogenstab','stablampe','deckenfluter'] },
    { id:'e14', bases:['e14'], general:'e14-leuchtmittel', led:'e14-led-leuchtmittel', halogen:'e14-halogenlampen', aliases:['e14'] },
    { id:'e27', bases:['e27'], general:'e27-leuchtmittel', led:'e27-led-leuchtmittel', halogen:'e27-halogenlampen', aliases:['e27','es27'] },
    { id:'e40', bases:['e40'], general:'e40-leuchtmittel', led:'e40-led-leuchtmittel', aliases:['e40'] },
    { id:'2g11', bases:['2g11'], general:'2g11-sockel', led:'2g11-led-leuchtmittel', fluorescent:'2g11-sockel', aliases:['2g11','dulux l','pl l','pll','ralux long'] },
    { id:'2g10', bases:['2g10'], general:'2g10-sockel', led:'2g10-led-leuchtmittel', fluorescent:'2g10-sockel', aliases:['2g10','dulux f'] },
    { id:'2g7', bases:['2g7'], general:'2g7-sockel', fluorescent:'2g7-sockel', aliases:['2g7','dulux s e'] },
    { id:'g23', bases:['g23'], general:'g23-sockel', led:'g23-led-leuchtmittel', fluorescent:'g23-sockel', aliases:['g23','dulux s','pl s','pls'] },
    { id:'g24d', bases:['g24d'], general:'g24d-sockel-2-pins', led:'g24d-led-leuchtmittel', fluorescent:'g24d-sockel-2-pins', aliases:['g24d','dulux d','pl c','plc'] },
    { id:'g24q', bases:['g24q'], general:'g24q-sockel-4-pins', led:'g24q-led-leuchtmittel', fluorescent:'g24q-sockel-4-pins', aliases:['g24q','dulux d e','pl c 4 pin','plc 4 pin'] },
    { id:'gx24d', bases:['gx24d'], general:'gx24d-sockel-2-pins', led:'gx24d-led-leuchtmittel', fluorescent:'gx24d-sockel-2-pins', aliases:['gx24d','dulux t','pl t','plt'] },
    { id:'gx24q', bases:['gx24q'], general:'gx24q-sockel-4-pins', led:'gx24q-led-leuchtmittel', fluorescent:'gx24q-sockel-4-pins', aliases:['gx24q','dulux t e','pl t 4 pin','plt 4 pin'] },
    { id:'gr8', bases:['gr8'], general:'gr8-sockel', led:'gr8-led-leuchtmittel', fluorescent:'gr8-sockel', aliases:['gr8'] },
    { id:'gr10q', bases:['gr10q'], general:'gr10q-sockel-4-pins', fluorescent:'gr10q-sockel-4-pins', aliases:['gr10q'] }
  ];

  var ALIAS_RULES = [
    { id:'led-tube', phrases:['led roehre','led tube','led tubes','ledroehre','roehrenlampe'], handles:['led-roehren','t8-led-roehren','t5-led-roehren','led-roehre-ohne-starter','t9-led-roehren-ringform'] },
    { id:'fluorescent-tube', phrases:['leuchtstoff roehre','leuchtstoff lampe','fluoreszenz roehre','neon roehre','neonlampe'], handles:['leuchtstoffroehren','t8-leuchtstoffroehren','t5-leuchtstoffroehren','t9-ringform-roehren'] },
    { id:'compact-fluorescent', phrases:['kompaktleuchtstoff lampe','energiespar lampe','sparlampe','kll','dulux','philips pl','osram dulux','tornado'], handles:['kompaktleuchtstofflampen','osram-kompaktleuchtstofflampen','philips-kompaktleuchtstofflampen','led-ersatz-kompaktleuchtstofflampen'] },
    { id:'lumilux', phrases:['lumilux'], handles:['osram-leuchtstoffroehren','osram-t8-leuchtstoffroehren','osram-t5-leuchtstoffroehren'] },
    { id:'osram-l', phrases:['osram l'], handles:['osram','osram-leuchtstoffroehren','osram-t8-leuchtstoffroehren','2g11-sockel','osram-kompaktleuchtstofflampen'] },
    { id:'philips-tl', phrases:['philips tl'], handles:['philips-leuchtstoffroehren','philips-t8-leuchtstoffroehren','philips-t5-leuchtstoffroehren'] },
    { id:'substitube', phrases:['substitube','substi tube'], handles:['osram-led-roehren','t8-led-roehren','t5-led-roehren'] },
    { id:'decostar', phrases:['decostar'], handles:['osram-decostar','gu5-3-halogenlampen','gu4-halogenlampen'] },
    { id:'haloline', phrases:['haloline'], handles:['osram-haloline','r7s-halogenlampen','r7s-leuchtmittel'] },
    { id:'halostar', ambiguous:true, phrases:['halostar'], handles:['g4-halogenlampen','gy6-35-halogenlampen','osram-halogen'] },
    { id:'halopin', phrases:['halopin'], handles:['g9-halogenlampen','g9-leuchtmittel','osram-halogen'] },
    { id:'parathom', phrases:['parathom'], handles:['osram','gu10-led-lampen','e27-led-leuchtmittel','e14-led-leuchtmittel'] },
    { id:'halolux', phrases:['halolux','halolux ceram'], handles:['osram-halogen','b15d-halogenlampen','e14-halogenlampen'] },
    { id:'halotronic', phrases:['halotronic','halotronic htm'], handles:['trafos','vorschaltgeraete-trafos-treiber','osram-vorschaltgeraete'] },
    { id:'philips-ledspot', ambiguous:true, phrases:['philips ledspot','master ledspot'], handles:['philips-reflektor-gu10','philips-reflektor-gu53','led-reflektorlampen'] },
    { id:'osram-led-star', phrases:['osram led star','led star'], handles:['osram','gu10-led-lampen','e27-led-leuchtmittel','e14-led-leuchtmittel'] },


    { id:'ofen', phrases:['ofenlampe','backofenlampe','backofen lampe'], handles:['ofenlampen'] },
    { id:'kuehlschrank', phrases:['kuehlschranklampe','kuehlschrank lampe'], handles:['kuehlschranklampen'] },
    { id:'infrarot', phrases:['infrarotlampe','infrarot lampe','waermelampe'], handles:['infrarotlampen'] },
    { id:'uvc', phrases:['uv c','uvc','entkeimung','tuv'], handles:['uv-c-lampen-entkeimung','speziallampen'] },
    { id:'uva', phrases:['uv a','uva','actinic','schwarzlicht'], handles:['uv-a-lampen-insekten-haerter','schwarzlichtlampen','speziallampen'] },
    { id:'uvb', phrases:['uv b','uvb','lichttherapie'], handles:['uv-b-lampen-lichttherapie','speziallampen'] },
    { id:'blacklight', phrases:['blacklight'], handles:['schwarzlichtlampen','uv-a-lampen-insekten-haerter','speziallampen'] },
    { id:'uv-general', ambiguous:true, phrases:['uv'], handles:['uv-c-lampen-entkeimung','uv-a-lampen-insekten-haerter','schwarzlichtlampen','speziallampen'] },
    { id:'generic-halogen', phrases:['halogen lampe','halogen'], handles:['halogenleuchtmittel','osram-halogen','r7s-halogenlampen','gu5-3-halogenlampen','g9-halogenlampen'] },
    { id:'discharge', phrases:['entladungslampe','hqi','hql','nav','son','cdm','mastercolour','powerball','natriumdampf','quecksilberdampf','halogen metalldampf'], handles:['entladungslampen','halogen-metalldampflampen','natriumdampflampen','quecksilberdampflampen'] },
    { id:'studio', phrases:['xenophot','studio lampe','projektionslampe','fotolampe'], handles:['studio-projektions-und-fotolampe','speziallampen'] },
    { id:'plusline', phrases:['plusline'], handles:['r7s-halogenlampen','r7s-leuchtmittel'] },
    { id:'vehicle-halogen', phrases:['h1 lampe','h3 lampe','h4 lampe','h7 lampe','h1','h3','h4','h7','halogen scheinwerfer'], handles:['halogen-scheinwerfer','fahrzeugbeleuchtung'] },
    { id:'panel', phrases:['led panel','panel'], handles:['led-panel','led-deckenleuchten'] },
    { id:'feuchtraum', phrases:['feuchtraumleuchte','wannenleuchte','nassraumleuchte','werkstatt leuchte','garage leuchte','keller leuchte'], handles:['led-feuchtraumleuchten','feuchtraumleuchten'] },
    { id:'under-cabinet', phrases:['unterbauleuchte','unterbau leuchte','led leiste'], handles:['led-unterbauleuchten','unterbauleuchten','lichtleisten'] },
    { id:'driver', phrases:['vorschaltgeraet','evg','kvg','vvg','ballast','drossel'], handles:['vorschaltgeraete','vorschaltgeraete-trafos-treiber','osram-vorschaltgeraete','philips-vorschaltgeraete'] },
    { id:'transformer', phrases:['led treiber','treiber','trafo','transformator','netzteil','driver'], handles:['vorschaltgeraete-trafos-treiber','treiber','trafos'] },
    { id:'starter', phrases:['starter','led starter','dummy starter','ueberbrueckungsstarter'], handles:['starter'] },
    { id:'wago', phrases:['wago klemme','wago','steckklemme','verbindungsklemme','dosenklemme'], handles:['wago','elektroinstallation'] },
    { id:'battery', phrases:['batterie','knopfzelle','akku','cr2032','cr2025','cr2016','cr2430','cr2450','cr123a','lr44','lr41','lr1130','lr03','lr6','lr14','lr20','6lr61','18650','9v block'], handles:['batterien','knopfzellen'] },
    { id:'linestra', phrases:['linienlampe','linestra','s14s','s14d','s14'], handles:['led-linienlampen'] },
    { id:'outdoor', phrases:['aussenleuchte','gartenleuchte'], handles:['aussenleuchten','leuchten'] },
    { id:'filament', phrases:['filament','edison','vintage','retro','kohlefaden'], handles:['led-filaments','e27-led-edisonform','e27-led-lampen-sonderform'] },
    { id:'bulb', phrases:['gluehbirne','gluehlampe','birne'], handles:['led-lampen','e27-led-gluehbirnen','gluehlampen'] }
  ];

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function readJson(selector) {
    var element = document.querySelector(selector);
    if (!element) return null;
    try { return JSON.parse(element.textContent); } catch (error) { return null; }
  }

  function preservePreview(path) {
    var target = new URL(path, location.origin);
    var current = new URL(location.href);
    ['preview_theme_id', 'preview_key'].forEach(function (key) {
      if (current.searchParams.has(key) && !target.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
    });
    return target.pathname + target.search + target.hash;
  }

  function collectionUrl(handle, filterPairs) {
    var target = new URL('/collections/' + handle, location.origin);
    (filterPairs || []).forEach(function (pair) {
      var values = Array.isArray(pair[1]) ? pair[1] : [pair[1]];
      values.forEach(function (value) {
        if (value !== null && value !== undefined && value !== '') target.searchParams.append(pair[0], String(value));
      });
    });
    /* KEIN sort_by anhaengen. Seit der Option-A-Umstellung steht jede produktive
       Collection auf sortOrder MANUAL und liefert damit von sich aus
       collection.default_sort_by == 'manual' — also genau die Option-A-Reihenfolge.
       Ein erzwungenes sort_by=best-selling wuerde sie durch Shopifys ungewichtete
       All-Time-Reihenfolge ersetzen. Am 13.08.2026 auf der Storefront gemessen:
       /collections/led-panel ohne Parameter -> Raenge 2092,3177,3282,3520,...
       mit sort_by=best-selling -> 4041,-,2092,-,-,-,3177,... */
    return preservePreview(target.pathname + target.search);
  }

  function nativeSearchUrl(query) {
    var target = new URL('/search', location.origin);
    target.searchParams.set('type', 'product');
    target.searchParams.set('q', feldSuche(query));
    return preservePreview(target.pathname + target.search);
  }

  /* Curated whole words only. Model/identifier tokens are never typo-corrected. */
  var TYPO_TOKEN_MAP = [
    [/\b(?:philis|phillips|philipps)\b/g, 'philips'],
    [/\b(?:ostam|osrsm|osrams|osran|osrm|osra)\b/g, 'osram'],
    [/\b(?:substuitube|substitub)\b/g, 'substitube'],
    [/\blumiux\b/g, 'lumilux'], [/\bleuchtstofflame\b/g, 'leuchtstofflampe'],
    [/\bleuchtmitrel\b/g, 'leuchtmittel'], [/\bkaltweis\b/g, 'kaltweiss']
  ];
  function typoNormalisieren(text) {
    if (/\b\d{6,}\b|\b(?:sku|ean|gtin|barcode|artikelnummer)\s*:/i.test(text)) return text;
    function wort(re, ziel) {
      text = text.replace(re, function (m, offset, all) {
        if (/[a-z0-9_.\/-]/i.test(all.charAt(offset - 1)) || /[a-z0-9_.\/-]/i.test(all.charAt(offset + m.length))) return m;
        return ziel;
      });
    }
    TYPO_TOKEN_MAP.forEach(function (paar) { wort(paar[0], paar[1]); });
    if (/\b(?:osram|s|d|l|t|f|el|longlife|g23|g24|2g11|gx24|w|watt)\b/.test(text)) wort(/\bdelux\b/g, 'dulux');
    if (!/\bb15d?\b|\bhalolux\b/.test(text)) wort(/\bgobe\b/g, 'globe');
    if (/\b(?:led|spot|strahler|lampe|leuchtmittel|osram|philips|par16)\b|\d+\s*w\b/.test(text)) wort(/\bfu10\b/g, 'gu10');
    return text;
  }

  function fold(value) {
    var text = String(value || '').replace(/[⁰¹²³⁴⁵⁶⁷⁸⁹₀₁₂₃₄₅₆₇₈₉]/g, function (c) {
      return String('⁰¹²³⁴⁵⁶⁷⁸⁹₀₁₂₃₄₅₆₇₈₉'.indexOf(c) % 10);
    }).toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
    if (text.normalize) text = text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    return text.replace(/&/g, ' und ');
  }


  function strictNormalize(value) {
    return fold(value).replace(/[–—−_\/\\+\-]+/g,' ').replace(/[^a-z0-9.,°\s]/g,' ').replace(/\s+/g,' ').trim();
  }

  function normalize(value) {
    var text = typoNormalisieren(fold(value));
    if (window.LMMTechRank && window.LMMTechRank.zerlege) text = window.LMMTechRank.zerlege(text).text;
    text = text.replace(/(^|[^a-z0-9])(osram|philips|ledvance|radium|sylvania|megaman)(?=(?:led(?:star|tube|lamp\w*|roehr\w*|spot\w*|fluter\w*|panel\w*)?|dulux\w*|lumilux|parathom|substitube|corepro|master|halolux|halopin|haloline|decostar|halostar|star|value|performance|classic)\b)/g, '$1$2 ')
      .replace(/\bled\s*star\b/g, 'led star')
      .replace(/\bkerzen(?:form|lampen|lampe|birnen|birne)?\b|\bkerze\b/g, ' kerze ')
      .replace(/\btropfen(?:form|lampen|lampe|birnen|birne|kugel)?\b/g, ' tropfen ')
      .replace(/\bglobe(?:form|lampen|lampe|birnen|birne|s)?\b/g, ' globe ')
      .replace(/\bedison(?:form|lampen|lampe|birnen|birne)?\b/g, ' edison ')
      .replace(/\b(\d+)\s*(?:v|volt)\b/g, '$1v');
    text = text
      .replace(/https?:\/\/\S+/g, ' url ')
      .replace(/\bosraml\b/g, ' osram l ')
      .replace(/\bosra\b/g, ' osram ')
      .replace(/\bduluxl\b/g, ' dulux l ')
      .replace(/\bduluxd\b/g, ' dulux d ')
      .replace(/\bduluxs\b/g, ' dulux s ')
      .replace(/\bduluxf\b/g, ' dulux f ')
      .replace(/\bduluxt\b/g, ' dulux t ')
      .replace(/\bsubstitub\b/g, ' substitube ')
      .replace(/\bledtube\b/g, ' led tube ')
      .replace(/\b(1800|2000|2200|2500|2700|3000|3500|4000|4500|5000|5700|6000|6500)\s*k\b/g, ' $1 k ')
      .replace(/\b([24])\s*p(?:in)?\b/g, ' $1 pin ')
      .replace(/\bgu\s*5\s*[-.,]?\s*3\b/g, ' gu53 ')
      .replace(/\bgu\s*5\b(?=\s+(?:led|halogen|lampe|leuchtmittel|strahler|spot))/g, ' gu53 ')
      .replace(/\bmr\s*16\b/g, ' mr16 ')
      .replace(/\bgu\s*10\b/g, ' gu10 ')
      .replace(/\bpar\s*16\b/g, ' par16 ')
      .replace(/\bgu\s*4\b/g, ' gu4 ')
      .replace(/\bmr\s*11\b/g, ' mr11 ')
      .replace(/\bg\s*53\b/g, ' g53 ')
      .replace(/\bar\s*111\b/g, ' ar111 ')
      .replace(/\bgy\s*6\s*[-.,]?\s*35\b/g, ' gy635 ')
      .replace(/\bg\s*6\s*[-.,]?\s*35\b/g, ' gy635 ')
      .replace(/\bgx\s*24\s*d\b/g, ' gx24d ')
      .replace(/\bgx\s*24\s*q\b/g, ' gx24q ')
      .replace(/\bg\s*24\s*d\b/g, ' g24d ')
      .replace(/\bg\s*24\s*q\b/g, ' g24q ')
      .replace(/\bgr\s*10\s*q\b/g, ' gr10q ')
      .replace(/\bgr\s*8\b/g, ' gr8 ')
      .replace(/\b2\s*g\s*11\b/g, ' 2g11 ')
      .replace(/\b2\s*g\s*10\b/g, ' 2g10 ')
      .replace(/\b2\s*g\s*7\b/g, ' 2g7 ')
      .replace(/\bb\s*22\s*d\b/g, ' b22d ')
      .replace(/\bba\s*15\s*d\b/g, ' ba15d ')
      .replace(/\bb\s*15\s*d\b/g, ' b15d ')
      .replace(/\br\s*7\s*s\b/g, ' r7s ')
      .replace(/\bs\s*14\s*s\b/g, ' s14s ')
      .replace(/\bs\s*14\s*d\b/g, ' s14d ')
      .replace(/\bs\s*14\b/g, ' s14 ')
      .replace(/\be\s*14\b/g, ' e14 ')
      .replace(/\be\s*27\b/g, ' e27 ')
      .replace(/\be\s*40\b/g, ' e40 ')
      .replace(/\bg\s*23\b/g, ' g23 ')
      .replace(/\bg\s*13\b/g, ' g13 ')
      .replace(/\bg\s*10\s*q\b/g, ' g10q ')
      .replace(/\bg\s*9\b/g, ' g9 ')
      .replace(/\bg\s*5\b/g, ' g5 ')
      .replace(/\bg\s*4\b/g, ' g4 ')
      .replace(/\btl\s*[- ]?\s*5\b/g, ' leuchtstoff t5 ')
      .replace(/\btl\s*[- ]?\s*d\b/g, ' leuchtstoff t8 ')
      .replace(/\bt\s*12\b/g, ' t12 ')
      .replace(/\bt\s*9\b/g, ' t9 ')
      .replace(/\bt\s*8\b/g, ' t8 ')
      .replace(/\bt\s*5\b/g, ' t5 ')
      .replace(/\bpl\s*[-/]?\s*c\b/g, ' plc ')
      .replace(/\bpl\s*[-/]?\s*l\b/g, ' pll ')
      .replace(/\bpl\s*[-/]?\s*s\b/g, ' pls ')
      .replace(/\bpl\s*[-/]?\s*t\b/g, ' plt ')
      .replace(/\bdulux\s*d\s*[/ ]?\s*e\b/g, ' dulux d e ')
      .replace(/\bdulux\s*t\s*[/ ]?\s*e\b/g, ' dulux t e ')
      .replace(/\bdulux\s*s\s*[/ ]?\s*e\b/g, ' dulux s e ')
      /* "LED Leuchtroehre" ist dieselbe Anfrage wie "LED Roehre" / "LED Tube".
         Ohne diese Zeile blieb "leuchtroehre" ein unbekanntes Wort: die Query traf
         weder die led-tube-Alias-Phrase noch eine Familie und endete im Fallback
         (gemessen 10.08.2026: mode=native, reason=fallback). Das blosse Wort
         "Leuchtroehre" ohne LED bleibt bewusst unangetastet. */
      .replace(/\bled\s*leucht\s*(?:roehre|roehren)\b/g, ' led roehre ')
      .replace(/\bled\s*(?:roehre|roehren)\b|\bledroehre\b|\bled\s*tubes?\b/g, ' led roehre ')
      .replace(/\bleuchtstoff\s*(?:roehre|roehren|lampe|lampen)\b/g, ' leuchtstoff roehre ')
      .replace(/\bfluoreszenz\s*(?:roehre|roehren)\b|\bfluorescent\s*tubes?\b/g, ' leuchtstoff roehre ')


      .replace(/\bneon\s*(?:roehre|roehren|rohre|rohren|lampe|lampen)\b|\bneonroehre\b/g, ' neon roehre ')
      .replace(/\bkompaktleuchtstoff\s*(?:lampe|lampen)\b|\bkompaktleuchtstofflampe\b/g, ' kompaktleuchtstoff lampe ')
      .replace(/\benergie\s*spar\s*(?:lampe|lampen)\b|\benergiesparlampe\b/g, ' energiespar lampe ')
      .replace(/\bspar\s*(?:lampe|lampen)\b|\bsparlampe\b/g, ' sparlampe ')
      .replace(/\bhalogen\s*(?:lampe|lampen)\b/g, ' halogen lampe ')
      .replace(/\bled\s*(?:lampe|lampen|leuchtmittel)\b/g, ' led lampe ')
      .replace(/\bgluehbirnen?\b|\bgluehlampen?\b/g, ' gluehbirne ')
      .replace(/\bbackofenlampen?\b/g, ' backofenlampe ')
      .replace(/\bkuehlschranklampen?\b/g, ' kuehlschranklampe ')
      .replace(/\binfrarotlampen?\b/g, ' infrarotlampe ')
      .replace(/\bfeuchtraumleuchten?\b/g, ' feuchtraumleuchte ')
      .replace(/\bwannenleuchten?\b/g, ' wannenleuchte ')
      .replace(/\bunterbauleuchten?\b/g, ' unterbauleuchte ')
      .replace(/\baussenwandleuchten?\b/g, ' aussen wandleuchte ')
      .replace(/\baussendeckenleuchten?\b/g, ' aussen deckenleuchte ')
      .replace(/\bdeckenleuchten?\b/g, ' deckenleuchte ')
      .replace(/\bwandleuchten?\b/g, ' wandleuchte ')
      .replace(/\beinbauleuchten?\b/g, ' einbauleuchte ')
      .replace(/\bwege(?:leuchte|leuchten)\b/g, ' wegeleuchte ')
      .replace(/\bhallenleuchten?\b/g, ' hallenleuchte ')
      .replace(/\btischleuchten?\b/g, ' tischleuchte ')
      .replace(/\bhaengeleuchten?\b/g, ' haengeleuchte ')
      .replace(/\bpanels?\b/g, ' panel ')
      .replace(/\b(?:lampe|lampen|leuchtmittel)\b/g, ' lampe ')
      .replace(/\b(?:roehre|roehren)\b/g, ' roehre ')
      .replace(/\b(?:leuchte|leuchten)\b/g, ' leuchte ')
      .replace(/\b(?:batterie|batterien)\b/g, ' batterie ')
      .replace(/\b(?:knopfzelle|knopfzellen)\b/g, ' knopfzelle ')
      .replace(/\b(?:fassung|fassungen)\b/g, ' fassung ')
      .replace(/\b(?:reflektor|reflektoren)\b/g, ' reflektor ')
      .replace(/\b(?:strahler|spots?|spotlights?)\b/g, ' strahler ')
      .replace(/\b(?:vorschaltgeraet|vorschaltgeraete)\b/g, ' vorschaltgeraet ')
      .replace(/\b(?:trafos?|transformatoren?)\b/g, ' trafo ')
      .replace(/\b(?:treiber|drivers?)\b/g, ' treiber ')
      .replace(/\b(?:starter|startgeraete?)\b/g, ' starter ')
      .replace(/\b(?:aussen|outdoor)\b/g, ' aussen ')
      .replace(/\b(?:innen|indoor)\b/g, ' innen ')
      .replace(/[–—−_\\+]+/g, ' ')
      .replace(/[^a-z0-9.,°/<>=≤≥\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return text;
  }

  function tokenize(value) {
    return normalize(value).replace(/[\/-]+/g, ' ').split(' ').filter(function (token) {
      return token && !GENERIC.has(token);
    });
  }

  function unique(values) { return Array.from(new Set(values)); }
  function hasWord(text, word) { return (' ' + text + ' ').indexOf(' ' + word + ' ') !== -1; }
  function phraseIn(text, phrase) { return (' ' + text + ' ').indexOf(' ' + normalize(phrase) + ' ') !== -1; }

  function detectBrand(text) {
    var normalized = normalize(text);
    if (phraseIn(normalized, 'osram') && phraseIn(normalized, 'ledvance')) return 'osram-ledvance';
    var matches = BRANDS.filter(function (brand) { return phraseIn(normalized, brand); });
    return matches.length ? normalize(matches[0]) : '';
  }

  function vendorValues(brand) {
    var values = {
      'osram':['Osram','Osram / Ledvance'],
      'ledvance':['LEDVANCE','Ledvance','Osram / Ledvance'],
      'osram-ledvance':['Osram','LEDVANCE','Ledvance','Osram / Ledvance'],
      'wago':['Wago'],
      'mennekes':['MENNEKES'],
      'phoenix contact':['PHOENIX CONTACT'],
      'walther':['WALTHER'],
      'juice technology':['juice technology']
    };
    if (values[brand]) return values[brand];
    return brand ? [brand.split(' ').map(function (part) { return part.charAt(0).toUpperCase() + part.slice(1); }).join(' ')] : [];
  }

  // Shape hints stay soft; devices and non-retrofit MR16 variants imply no socket.
  function findeSockel(text) {
    if (/\b(?:treiber|trafos?|drivers?|netzteile?|adapter|fassung)\b/.test(text)) return null;
    if (/\bpar16\b/.test(text)) return 'gu10';
    if (/\bmr16\b/.test(text) && !/\b(?:cdm\w*|mastercolour|hqi|hid|24\s*v)\b/.test(text)) return 'gu5.3';
    if (/\bmr11\b/.test(text)) return 'gu4';
    if (/\bar111\b/.test(text)) return 'g53';
    return null;
  }

  function extractBases(text) {
    var normalized = normalize(text);
    var found = KNOWN_BASES.filter(function (base) { return hasWord(normalized, base); });
    ['t5','t8','t9','t12'].forEach(function (base) { if (hasWord(normalized, base)) found.push(base); });
    if (!found.length) {
      var fallback = window.LMMTechRank ? window.LMMTechRank.parse(normalized).sockelFallback :
        findeSockel(normalized);
      if (fallback) found.push(fallback === 'gu5.3' ? 'gu53' : fallback);
    }
    return unique(found);
  }

  function detectTechnology(text) {
    var normalized = normalize(text);
    if (/\b(?:led|filament|parathom|superstar|warmglow)\b/.test(normalized)) return 'led';
    if (/\b(?:hid|hqi|hql|cdm|entladung)\b/.test(normalized)) return 'hid';
    if (/\b(?:incandescent|gluehdraht|gluehfaden|backofen\w*|kuehlschrank\w*|naehmaschine\w*|salzlampe\w*|infrarot\w*)\b/.test(normalized)) return 'incandescent';
    if (hasWord(normalized, 'halogen') || /\b(halopin|haloline|decostar|halostar|halolux)\b/.test(normalized)) return 'halogen';
    if (/\b(t5|g5)\b/.test(normalized) && /\b(he|ho|tl5)\b/.test(normalized)) return 'fluorescent';
    if (/\b(dulux|lumilux|plc|pll|pls|plt|kompaktleuchtstoff|kll)\b/.test(normalized)) return 'fluorescent';
    if (hasWord(normalized, 'fluorescent') || hasWord(normalized, 'leuchtstoff') || hasWord(normalized, 'kompaktleuchtstoff') || hasWord(normalized, 'kll') || hasWord(normalized, 'neon')) return 'fluorescent';
    if (hasWord(normalized, 'xenon')) return 'xenon';
    return '';
  }

  function detectKind(text) {
    var normalized = normalize(text);
    if (/\b(batterie|knopfzelle|akku|ladegeraet)\b/.test(normalized)) return 'battery';
    if (/\b(fassung|adapter|zubehoer|kabel|verbinder|dimmer|starter|vorschaltgeraet|trafo|treiber|steuergeraet)\b/.test(normalized)) return 'accessory';
    if (/\b(wallbox|ladekabel|elektroinstallation|steckdose|schalter|klemme)\b/.test(normalized)) return 'electrical';
    if (/\b(leuchte|panel|downlight|einbaustrahler|fluter|lichtband|lichtleiste)\b/.test(normalized)) return 'fixture';
    if (/\b(lampe|roehre|leuchtstoff|led|halogen|xenon|infrarot|uv|gluehbirne)\b/.test(normalized)) return 'lamp';
    return '';
  }

  function collectionVisualMap() {
    var map = {};
    function add(url, image) {
      if (!url || !image) return;
      try { map[new URL(url, location.origin).pathname] = image; } catch (error) { /* ignore invalid optional menu data */ }
    }
    var visuals = readJson('[data-lmm-visuals]') || {};
    var hover = readJson('[data-lmm-hover-visuals]') || {};
    Object.keys(visuals).forEach(function (key) {
      var group = visuals[key] || {};
      (group.tiles || []).forEach(function (tile) { add(tile.u, tile.img); });
      if (group.cta && group.tiles && group.tiles[0]) add(group.cta.u, group.tiles[0].img);
    });
    Object.keys(hover).forEach(function (key) {
      var item = hover[key] || {};
      add(key, item.img);
    });
    return map;
  }

  function initCatalog() {
    var raw = readJson('#lmm-search-catalog-data') || [];
    var visualMap = collectionVisualMap();
    catalog = raw.map(function (item) {
      var title = String(item.title || '');
      var handle = String(item.handle || '');
      var normalized = normalize(title + ' ' + handle);
      var tokens = unique(tokenize(title + ' ' + handle));
      return {
        id: item.id || '', title: title, handle: handle, url: item.url || ('/collections/' + handle),
        count: Number(item.count || 0), image: item.image || visualMap['/collections/' + handle] || '', normalized: normalized,
        titleNormalized: normalize(title), tokens: tokens, tokenSet: new Set(tokens),
        bases: extractBases(title + ' ' + handle), technology: detectTechnology(title + ' ' + handle),
        kind: detectKind(title + ' ' + handle), brand: detectBrand(title + ' ' + handle)
      };
    }).filter(function (item) { return item.handle && item.title; });
    catalogByHandle = new Map(catalog.map(function (item) { return [item.handle, item]; }));
  }

  function countNumericSignals(value) {
    var matches = String(value || '').match(/\d+(?:[.,]\d+)?/g) || [];
    return matches.length;
  }

  function identifierQuery(raw) {
    var value = String(raw || '').trim();
    var normalized = normalize(value);
    if (!value) return false;
    if (/^variants\.(?:sku|barcode):/i.test(value)) return true;
    if (/\burl\b/.test(normalized) || /\b(ean|gtin|sku|artikelnummer|art\.?\s*nr\.?|bestellnummer|hersteller(?:nummer|nr))\b/i.test(value)) return true;
    if (/^\d{8,14}$/.test(value.replace(/\s/g, '')) || /\b\d{8,14}\b/.test(value)) return true;
    /* Serien-/Familien-Suchen (kompletter Katalog: Kompakt, Röhren, Halogen, LED,
       Entladung, UV) sind Kategorie-Suchen, keine Artikelnummern — sonst kippt die
       series+technical-Heuristik unten Eingaben wie "dulux d 18w" oder "osram l 18w"
       nach exact und Kategorien-Spalte/Routing verschwinden. Jede Query, die eine
       ALIAS_RULES-Phrase enthält (z. B. "osram l" → Lumilux-Röhren), zählt ebenfalls
       als Kategorie-Suche. Exact bleiben: Queries mit 5+-stelliger Nummer
       (Hersteller-/Bestellnummer), expliziter Pin-Index ("g24d-3") und die
       Master-Vollkombination Serie+Pin+Farbcode weiter unten. */
    var compactFamilyQuery = !/\b\d{5,}\b/.test(normalized) &&
      !/\b(?:g24[dq]|gx24[dq])\s*-\s*\d\b/.test(normalized) &&
      (/\b(?:pl[lcst]|2g7|2g10|2g11|g23|g24[dq]|gx24[dq]|dulux(?:\s+[dlstf]\b)?|lumilux|substitube|parathom|corepro|master|mastercolour|haloline|decostar|halostar|halopin|xenophot|powerball|cdm|hqi|hql|nav|son|tuv|actinic|tornado|plusline|lynx|ralux|bonalux|grolux)\b/.test(normalized) ||
       !!aliasMatch(normalized));
    if (compactFamilyQuery) {
      var explicitSeries = /\b(?:master|corepro|ralux)\b/.test(normalized);
      var explicitPin = /\b[24]\s*(?:p|pin)\b/i.test(value);
      var explicitColorCode = /\/\s*(?:827|830|840|865|930|940|950|965)\b/.test(value);
      if (!(explicitSeries && explicitPin && explicitColorCode)) return false;
    }
    /* Sockel-/Typ-Codes (auch Bajonett/Linienlampe) und Batterie-Zellencodes sind
       Kategorie-Begriffe, keine Artikelnummern. */
    var commonCode = /^(?:par16|mr16|mr11|ar111|h[1347]|t[58912]|e(?:14|27|40)|r7s|b(?:a)?15d|b22d|s14[sd]?|g(?:4|5|9|10q|12|13|23|24[adq]?\d?|53)|gx(?:24[adq]?\d?|53)|gu(?:4|5|10|53)|gy635|gr(?:8|10q)|2g(?:7|10|11)|(?:cr|br|dl)\d{3,4}[a-z]?|cr123a?|(?:lr|sr|ag|pr|hr|fr)\d{1,4}[a-z]{0,2}|6lr61|1[48]650|14500|26650)$/;
    var codeTokens = value.toLowerCase().match(/[a-z0-9-]+/g) || [];
    if (codeTokens.some(function (token) {
      var compact = token.replace(/-/g, '');


      var letters = (compact.match(/[a-z]/g) || []).length;
      var digits = (compact.match(/\d/g) || []).length;
      if (/^(?:\d+(?:k|w|kw|lm|mm|cm)|ip\d{2})$/.test(compact)) return false;
      return compact.length >= 5 && letters >= 1 && digits >= 2 && !commonCode.test(compact);
    })) return true;
    if (/\b(?:st|h|l|fh|fq|ho|he|t5l|tld|tl5)\s*\d{2,4}(?:\s*w)?(?:\s*[/ -]\s*\d{3})?\b/i.test(value)) return true;
    /* "14W/840" & Co. (Watt + Lichtfarbcode) bezeichnen eine GATTUNG, keinen einzelnen
       Artikel — solche Suchen bleiben native MIT Bestseller-Sortierung (Chris: die
       meistverkaufte 14W/840-Röhre muss oben stehen, nicht Relevanz-Zufall). Identifier
       bleibt nur die alte Zweiteil-Notation mit Bindestrich-Farbcode ("18W/33-640"). */
    if (/\b\d+(?:[.,]\d+)?\s*w\s*\/\s*\d{2}\s*-\s*\d{3}\b/i.test(value)) return true;

    var series = /\b(dulux|lumilux|substitube|haloline|decostar|halostar|halopin|parathom|mastercolour|powerball|xenophot|corepro|master|star|value|performance|tuv|actinic|cdm|hqi|hql|nav|son|tl\s*d|tl5|ralux)\b/.test(normalized);
    var technical = /\b\d+(?:[.,]\d+)?\s*(?:w|kw)\b|\b(?:827|830|840|865|930|940|950|965)\b|\b\d{3,4}\s*mm\b/.test(normalized);
    if (series && technical) return true;
    if (series && /\b\d{5,}\b/.test(normalized)) return true;
    if (detectBrand(normalized) && /\b\d{5,}\b/.test(normalized)) return true;
    if (/\b(?:hns|st8au)[- ]?\d{1,4}[a-z0-9/-]*\b/i.test(value) || /\b(?:st|h|l|fh|fq|ho|he|t5l|tld|tl5)[- ]\d{2,4}[a-z0-9/-]*\b/i.test(value)) return true;
    if (/\b\d{1,3}\s*x\s*\d{3,4}\s*mm\b/i.test(value)) return true;
    if (countNumericSignals(value) >= 2 && series && extractBases(normalized).length === 0) return true;
    return false;
  }

  /* The header loads this asset alone. Keep its technical fallback aligned with
     lmm-tech-rank; the regression suite exercises both dependency configurations. */
  function standaloneTechSpec(text) {
    var FARB = '[89](?:2[257]|3[035]|40|5[07]|6[05])';
    function klein(value) { return fold(value); }
    function zahl(value) { return Number(String(value).replace(',', '.')); }
    var RE_FARB = new RegExp('(?:^|[^0-9])(' + FARB + ')(?:$|[^0-9])');
    var RE_ERSATZ_STARK = /\bersatz\w*\b|\bersetzt\b|\bersetzen\b|\balternativ\w*\b|\bumruest\w*\b|\bstatt\b|\banstelle\b|\bentspricht\b|\bumbau\b|\bretrofit\b|\baustausch\w*\b|\btausch\w*\b/;
    var RE_LEUCHTE_QUERY = /\bleuchten?\b|\bfeuchtraum\w*\b|\bwannenleuchte\w*\b|\bbalkenleuchte\w*\b|\blichtband\w*\b|\bstrahler\b|\bdownlight\w*\b|\bpanel\w*\b|\bspiegelschrank\w*\b/;
    var RE_QWATT = /(?:^|[^0-9.,\-])(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?(?:$|[^a-z0-9])/;
    var RE_QBEREICH = /(?:^|[^0-9.,])(\d{1,3}(?:[.,]\d)?)\s*-\s*(\d{1,3}(?:[.,]\d)?)\s*w/;
    var RE_QKELVIN = /(?:^|[^0-9.,])([1-9]\d{3})\s*k(?:elvin)?(?:$|[^a-z0-9])/;
    var RE_QLUMEN = /(?:^|[^0-9.,])(\d{2,6})\s*(?:lm|lumen)(?:$|[^a-z0-9])/;
    var RE_ROEHRE = /(?:^|[^a-z0-9])(?:g13|g5|2gx13|t8|t5|t12|tl|tld|tl5|roehren?|leuchtstoffroehren?|leuchtroehren?|neonroehren?|tubes?|ledtube|substitube)(?:$|[^0-9])/;
    var RE_GERAET_QUERY = /\b(?:treiber|trafos?|transformator\w*|netzteile?|drivers?|vorschaltgeraete?|evg|kvg|vvg|starter|dimmer|leuchten?|deckenleuchten?|fluter|panels?|sensor|notlicht)\b/;
    var RE_KONVENTIONELL = /\b(?:backofen\w*|ofen\w*|kuehlschrank\w*|naehmaschine\w*|salzlampe\w*|infrarot\w*|halogen\w*|halopin|haloline|halostar|decostar|halolux|dulux\w*|lumilux|leuchtstoff\w*|fluorescent|incandescent|hid|tuv|hns|hqi|hql|cdm\w*|nav|son|entladung\w*)\b/;
    function expliziteErsatzleistung(text) {
      // Two stated powers connected by a replacement word are independent of word order.
      var werte = [], muster = /\b(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\b/g, treffer;
      while ((treffer = muster.exec(text))) werte.push({ watt: zahl(treffer[1]), start: treffer.index, end: muster.lastIndex });
      if (werte.length === 2 && werte[0].watt !== werte[1].watt
          && /\b(?:ersetzt|ersatz|statt|anstelle|entspricht)\b/.test(text.slice(werte[0].end, werte[1].start))) {
        return { watt: Math.max(werte[0].watt, werte[1].watt), wattEigen: Math.min(werte[0].watt, werte[1].watt) };
      }
      var paar = /\b(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\s*(?:ersetzt\s*(?:durch)?|ersatz\s*(?:fuer)?|statt|anstelle\s*(?:von)?|entspricht)\s*(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\b/.exec(text);
      if (paar && zahl(paar[1]) !== zahl(paar[2])) {
        return { watt: Math.max(zahl(paar[1]), zahl(paar[2])), wattEigen: Math.min(zahl(paar[1]), zahl(paar[2])) };
      }
      var vor = /\b(?:ersetzt|ersatz\s*(?:fuer)?|statt|anstelle\s*(?:von)?|entspricht)\s*(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\b/.exec(text);
      var nach = /\b(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\s*(?:ersatz|statt|ersetzt\s*durch)\b/.exec(text);
      var bindung = nach || vor;
      if (!bindung) return null;
      var rest = text.slice(0, bindung.index) + ' ' + text.slice(bindung.index + bindung[0].length);
      var eigen = rest.match(/\b(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\b/g) || [];
      return { watt: zahl(bindung[1]), wattEigen: eigen.length === 1 ? zahl(eigen[0].match(/[\d.,]+/)[0]) : null };
    }

    function lengthComparator(text) {
      text = klein(text);
      var op = '(?:\\b(?:laenger|kuerzer|groesser|kleiner|mehr|weniger)\\s+als\\b|\\b(?:ueber|unter|maximal|mindestens|hoechstens|bis|ab)\\b|\\b(?:max|min)\\b\\.?|[<>]=?|[≤≥])';
      var value = '\\d+(?:[.,]\\d+)?';
      if (new RegExp(op + '\\s*(?:laenge\\s*[:=]?\\s*)?' + value + '\\s*(?:mm|cm|m(?:eter|etre)?)\\b').test(text)) return true;
      if (new RegExp('\\blaenge\\s*[:=]?\\s*' + op + '\\s*' + value + '(?![\\d.,])(?:\\s*(?:mm|cm|m)\\b|(?=\\s*(?:$|[;,])))').test(text)) return true;
      return /\b(?:r7s|halogenstab|stablampe)\b/.test(text)
        && new RegExp(op + '\\s*(?:78|118|114)\\b(?!\\s*(?:lm|lumen|w(?:att)?|k(?:elvin)?|v(?:olt)?|grad|stueck)\\b)').test(text);
    }

    function wattModus(spec, text) {
      if (spec.wattBereich) return 'direct';
      if (spec.watt === null) return 'none';
      var effSockel = spec.sockel || spec.sockelFallback;
      if (spec.ersatzAbsichtStark || spec.wattEigen !== null) return 'replaces';
      var geraetText = spec.roehrenKontext || spec.ersatzAbsichtStark ? text.replace(/\b(?:evg|kvg|vvg)\b/g, '') : text;
      if (RE_GERAET_QUERY.test(geraetText)
          || (!effSockel && !spec.roehrenKontext && RE_LEUCHTE_QUERY.test(text))) return 'actual';
      var w = spec.watt;
      var konventionell = RE_KONVENTIONELL.test(text);
      if (konventionell && !spec.ersatzAbsichtStark) return 'actual';
      if (/(?:^|\s)\d{1,2}(?:[.,]\d)?\s+\d{2,3}\s*w\b/.test(text)) return 'replaces';
      if (spec.lumen !== null && w > 0 && spec.lumen / w >= 45) return 'actual';
      if (!konventionell && spec.lumen !== null && w >= 25 && spec.lumen / w <= 22
          && /\b(?:led|ledvance|philips|osram)\b/.test(text)) return 'replaces';
      if (spec.roehrenKontext) {
        var klassisch = [14,15,18,21,24,28,30,35,36,38,49,54,58,70,80];
        var ledEigen = [7,7.5,8,9,10,10.5,11,12,12.5,14.5,14.7,15.5,16,16.5,17.5,18.2,19,20,22,23,25,26,27];
        var ledSerie = /\b(?:(?:master|corepro)\s+led(?:tube|\s+(?:tube|roehre))|substitube)\b/.test(text);
        if (ledSerie && ledEigen.indexOf(w) !== -1) return 'actual';
        return /\bled\b|\bledtube\b|\bsubstitube\b/.test(text) && klassisch.indexOf(w) !== -1 ? 'replaces' : 'actual';
      }
      if (konventionell) return 'actual';
      var kleinSockel = ['e14','gu10','gu5.3','g9','g4','gy6.35','b22d'].indexOf(effSockel) !== -1;
      var form = /\b(?:gluehbirne|gluehlampe|birne|kerze|kerzenform|kerzenlampe|tropfen|globe|filament|edison|classic|parathom|ledstar|led star|superstar|corepro|warmglow)\b/.test(text);
      var klassischerWert = (kleinSockel && w >= 20 && w <= 100)
        || ((effSockel === 'e27' || (!effSockel && form)) && [25,35,40,50,60,75,100,120,150,200].indexOf(Math.round(w)) !== -1);
      if (klassischerWert) {
        if (effSockel === 'gu10') return 'replaces';
        if (/\b(?:led|ledstar|led star|parathom|substitube|corepro|master\s*led|classic\s*[abp]\s*\d+|filament|retrofit|superstar|warmglow)\b/.test(text)) return 'replaces';
        if ((spec.farbcode || spec.kelvin !== null) && ['gu10','e14','e27','b22d','g9','gu5.3'].indexOf(effSockel) !== -1) return 'replaces';
        if (!spec.farbcode && spec.kelvin === null) return 'ambiguous';
      }
      return 'actual';
    }
    var spec = { watt: null, wattEigen: null, wattBereich: null, wattModus: 'none',
      farbcode: null, kelvin: null, lumen: null, sockel: null, sockelFallback: null, dimmbar: null,
      ersatzAbsichtStark: RE_ERSATZ_STARK.test(text), roehrenKontext: RE_ROEHRE.test(text),
      lengthComparator: lengthComparator(text) };
    var bases = KNOWN_BASES.filter(function (base) { return hasWord(text, base); });
    spec.sockel = bases.length ? (bases[0] === 'gu53' ? 'gu5.3' : bases[0] === 'gy635' ? 'gy6.35' : bases[0]) : null;
    spec.sockelFallback = spec.sockel ? null : findeSockel(text);
    var explicit = expliziteErsatzleistung(text), m;
    if (explicit) { spec.watt = explicit.watt; spec.wattEigen = explicit.wattEigen; spec.ersatzAbsichtStark = true; }
    else if ((m = RE_QBEREICH.exec(text))) {
      if (!RE_GERAET_QUERY.test(text) && !RE_LEUCHTE_QUERY.test(text) && !RE_KONVENTIONELL.test(text)
          && zahl(m[1]) < 15 && zahl(m[2]) >= 20 && zahl(m[2]) >= zahl(m[1]) * 3) {
        spec.wattEigen = zahl(m[1]); spec.watt = zahl(m[2]);
      } else spec.wattBereich = [zahl(m[1]), zahl(m[2])];
    } else if ((m = RE_QWATT.exec(text))) spec.watt = zahl(m[1]);
    if ((m = RE_FARB.exec(text))) spec.farbcode = m[1];
    if ((m = RE_QKELVIN.exec(text))) spec.kelvin = zahl(m[1]);
    else if (/\b(?:kalt\s*weiss|neutral\s*weiss|cool white)\b/.test(text)) spec.kelvin = 4000;
    else if (/\b(?:tageslicht\s*weiss|tageslicht|daylight)\b/.test(text)) spec.kelvin = 6500;
    if ((m = RE_QLUMEN.exec(text))) spec.lumen = zahl(m[1]);
    if (spec.farbcode && new RegExp('\\b' + spec.farbcode + '\\s*(?:lm|lumen)\\b').test(text)) spec.farbcode = null;
    var dimmText = text.replace(/[-/]+/g, ' ');
    if (/\b(?:(?:nicht|non|not|ohne)\s*dimm(?:bar\w*|able|en)?|undimmable)\b/.test(dimmText)) spec.dimmbar = false;
    else if (/\bdimm(?:bar\w*|able|en)\b/.test(dimmText)) spec.dimmbar = true;
    spec.wattModus = wattModus(spec, text);
    return spec;
  }

  function replacesListe(w) {
    // Header-Solo mirrors TechRank's finder classes; parity tests cover their edges.
    var klassen = [[10,30],[32,39],[40,49],[50,55],[60,80],[90,120]];
    var klasse = window.LMMTechRank && typeof window.LMMTechRank.ersatzKlasse === 'function'
      ? window.LMMTechRank.ersatzKlasse(w)
      : klassen.filter(function (k) { return Number(w) >= k[0] && Number(w) <= k[1]; })[0];
    if (!klasse) return null;
    var liste = [wattFilterWert(w)];
    for (var kw = Math.ceil(klasse[0]); kw <= klasse[1]; kw += 1) {
      var kws = wattFilterWert(kw);
      if (liste.indexOf(kws) === -1) liste.push(kws);
    }
    return liste;
  }

  function parseModifiers(normalized) {
    var techSpec = (window.LMMTechRank && typeof window.LMMTechRank.parse === 'function')
      ? window.LMMTechRank.parse(normalized) : standaloneTechSpec(normalized);
    var result = { kelvin: [], code: null, length: null, dimmable: null, wattage: null, voltage: null, replaces: null, replacesListe: null, lumen: null, beam: null, energy: null, ip: null };
    var match = normalized.match(/\b(1800|2000|2200|2500|2700|3000|3500|4000|4500|5000|5700|6000|6500)\s*k\b/);
    if (match) result.kelvin = [match[1]];
    else if ((match = normalized.match(/\b([89](?:2[257]|3[035]|40|5[07]|6[05]))\b/))) {
      /* Ein AUSDRUECKLICHER Farbcode wird direkt als color_code-Filter
         gesetzt, nicht mehr ueber Kelvin angenaehert (Chris 2026-08-14).
         Die Naeherung war doppelt falsch — live gemessen 2026-08-14:
           827 -> kelvin=2700+3000 zog die 830er herein (9 statt 3 Treffer,
                  erster Treffer ein 830er-Artikel), und
           840 -> kelvin=4000 verlor den Rang-18-Artikel 1000111245, der
                  color_code=840 traegt, aber keinen passenden Kelvinwert.
         Die kanonische Codeliste (erste Ziffer Ra-Band, letzte zwei x 100 =
         Kelvin) ist deckungsgleich mit lmm-tech-rank; 9xx-Codes (927/930/…)
         funktionieren damit erstmals auch im Routing. Wortformen wie
         "warmweiss" bleiben Kelvin — fuer sie gibt es keinen einzelnen Code. */
      result.code = match[1];
    }
    else if (/warm\s*weiss|warmweiss|warm white|warmton|interna/.test(normalized)) result.kelvin = ['2700','3000'];
    else if (/neutral\s*weiss|neutralweiss|kalt\s*weiss|kaltweiss|cool white/.test(normalized)) result.kelvin = ['4000'];
    else if (/tageslicht\s*weiss|tageslichtweiss|tageslicht|daylight|cool daylight/.test(normalized)) result.kelvin = ['6500'];

    match = normalized.match(/\b([4-9]\d|\d{3,4})\s*mm\b/);
    if (match) result.length = Number(match[1]);
    else if ((match = normalized.match(/\b(\d{2,3}(?:[.,]\d+)?)\s*cm\b/))) result.length = Math.round(Number(match[1].replace(',','.')) * 10);
    else if ((match = normalized.match(/\b(\d(?:[.,]\d+)?)\s*m(?:eter|etre)?\b/))) result.length = Math.round(Number(match[1].replace(',','.')) * 1000);

    result.lengthComparator = techSpec.lengthComparator;
    if (result.lengthComparator) result.length = null;
    else if (!result.length && /\b(?:r7s|halogenstab|stablampe)\b/.test(normalized) && (match = normalized.match(/\b(78|118|114)\b/))) result.length = Number(match[1]);

    result.dimmable = typeof techSpec.dimmbar === 'boolean' ? String(techSpec.dimmbar) : null;

    /* Ersatz-/Umruestabsicht (Chris 2026-07-30, Nebenbefund im selben Datenfluss).
       Steht in der Query ein ausdrueckliches Ersatzwort, ist die genannte
       Wattzahl die ERSETZTE Leistung — nicht die tatsaechliche. Vorher griff nur
       die enge Form "ersetzt 16W" / "ersatz fuer 16W"; "LED Ersatz 16W/840 G13"
       fiel durch und wurde als tatsaechliche Leistung gefiltert.
       Read-only gemessen auf /collections/t8-led-roehren mit kelvin=4000:
         replaces_wattage=16.0 ->  2   wattage=16.0 -> 7
         replaces_wattage=18.0 -> 23   wattage=18.0 -> 6
         replaces_wattage=36.0 -> 39   wattage=36.0 -> 0
       Die Definition der Ersatzabsicht kommt aus der GETEILTEN Engine
       snippets/lmm-tech-rank — damit Router und Ranking nicht zwei verschiedene
        Vorstellungen davon haben, was eine Ersatzsuche ist. Header-Solo verwendet
        den durch Paritaetstests abgesicherten standaloneTechSpec-Fallback. */
    if (techSpec) {
      result.wattModus = techSpec.wattModus;
      result.wattAmbiguous = techSpec.wattModus === 'ambiguous';
      if (techSpec.wattEigen !== null) result.wattageEigen = String(techSpec.wattEigen);
    }
    if (techSpec && techSpec.watt !== null) {
      result.wattModus = techSpec.wattModus;
      if (techSpec.wattModus === 'replaces') result.replaces = String(techSpec.watt);
      else if (techSpec.wattModus === 'actual' || techSpec.wattModus === 'ambiguous') result.wattage = String(techSpec.watt);
      result.wattAmbiguous = techSpec.wattModus === 'ambiguous';
    }

    /* Ersatzleistungs-KLASSE (Chris Phase 12, 2026-08-13; hier seit
       2026-08-14 auch fuer Collection-Routen): ausserhalb des
       Roehrenkontexts gehoeren alle Werte der Leuchtmittel-Finder-Klasse zur
       Anfrage — "50 W" laedt auch "ersetzt 51 W"/"ersetzt 55 W" (die
       Collection-Facette "~50 W" = 50-55 W fuehrt 126 Artikel, der exakte
       Wert nur 120; die 6 fehlenden sind die 51-W-Spots). Quelle der Klasse
        ist LMMTechRank.ersatzKlasse; Header-Solo spiegelt dieselben Klassen.
       Bei Roehren bleibt der Ersatzwert exakt (laengen-/systemkritisch). */
    if (result.replaces && techSpec && !techSpec.roehrenKontext) {
      result.replacesListe = replacesListe(result.replaces);
    }

    match = normalized.match(/\b(\d{1,3})\s*(?:v|volt)\b/); if (match) result.voltage = match[1];
    match = normalized.match(/\b(\d{2,5})\s*(?:lm|lumen)\b/); if (match) result.lumen = match[1];
    /* FIX 2026-08-13: hinter "°" kann nie eine \b-Wortgrenze stehen (° ist
       kein Wortzeichen) — der °-Zweig war toter Code, "120°" endete als
       unaufgeloestes Token in mode=ambiguous. Jetzt: "120°", "120 °",
       "120 Grad", "120grad". */
    match = normalized.match(/\b(\d{1,3})\s*(?:°|grad(?![a-z]))(?![a-z0-9])/); if (match) result.beam = match[1];
    match = normalized.match(/\b(?:energieklasse|energieeffizienzklasse|eek)\s*([a-g])\b/); if (match) result.energy = match[1].toUpperCase();
    match = normalized.match(/\bip\s*(20|21|23|40|44|54|55|64|65|66|67|68)\b/); if (match) result.ip = 'IP' + match[1];
    return result;
  }

  /* Wertformat der Wattfilter (Chris 2026-07-30, Nebenbefund im selben Datenfluss).
     specs.wattage und specs.replaces_wattage sind Dezimal-Metafelder; Shopify
     indiziert sie als "16.0". Ein Filter "…wattage=16" trifft NICHTS — und genau
     den hat der Router bisher gebaut. Read-only belegt auf
     /collections/t8-led-roehren mit kelvin=4000: JEDER ungepolsterte Wert
     lieferte 0 Treffer (7, 16, 18, 36, 58 — beide Felder), "16.0" lieferte 7.
     Daran liefen alle LED-/Ersatz-Techniksuchen in eine leere Seite.
     Kelvin, Laenge, Lumen und Beam sind Integer-Metafelder und bleiben unberuehrt
     (kelvin=4000 ist nachgemessen wirksam). */
  function wattFilterWert(v) {
    var x = Number(String(v).replace(',', '.'));
    if (!isFinite(x)) return v;
    return Math.abs(x - Math.round(x)) < 0.001 ? x.toFixed(1) : String(x);
  }

  function modifierPairs(modifiers, kind, technology, skipLength) {
    var pairs = [];
    var lighting = kind === 'lamp' || kind === 'fixture' || technology === 'led' || technology === 'halogen' || technology === 'fluorescent';
    if (lighting && modifiers.kelvin.length) pairs.push([FILTERS.kelvin, modifiers.kelvin]);
    if (lighting && modifiers.code) pairs.push([FILTERS.code, modifiers.code]);
    if (lighting && modifiers.length && !skipLength) pairs.push([FILTERS.length, modifiers.length]);
    if (lighting && modifiers.dimmable !== null) pairs.push([FILTERS.dimmable, modifiers.dimmable]);
    if (lighting && modifiers.wattage && !modifiers.wattAmbiguous) pairs.push([FILTERS.wattage, wattFilterWert(modifiers.wattage)]);
    if (lighting && modifiers.replaces) pairs.push([FILTERS.replaces, modifiers.replacesListe || wattFilterWert(modifiers.replaces)]);
    if (lighting && modifiers.lumen) pairs.push([FILTERS.lumen, modifiers.lumen]);
    if (lighting && modifiers.beam) pairs.push([FILTERS.beam, modifiers.beam]);
    if (lighting && modifiers.energy) pairs.push([FILTERS.energy, modifiers.energy]);
    if (kind === 'fixture' && modifiers.ip) pairs.push([FILTERS.ip, modifiers.ip]);
    return pairs;
  }

  function coreTokens(normalized, brand, modifiers) {
    var brandTokens = brand ? normalize(brand).split(' ') : [];
    var tokens = tokenize(normalized).filter(function (token) {
      if (MODIFIER.has(token) || SERIES.has(token) || brandTokens.indexOf(token) !== -1) return false;
      if (/^\d+(?:[.,]\d+)?$/.test(token)) return false;
      if (/^12v$/.test(token) && /\b(?:g4|gu53|mr16|gu4|mr11|gy635)\b/.test(normalized)) return false;
      if (/^(?:220|230|240)v$/.test(token) && /\b(?:e14|e27|e40|gu10|g9|r7s|b22d)\b/.test(normalized)) return false;
      if (/^\d+(?:[.,]\d+)?(?:w|kw|lm|mm|cm|k)$/.test(token)) return false;
      if (/^\d{3,4}k$/.test(token)) return false;
      /* "120°"/"120grad" ist ein aufgeloester Beam-Modifier (2026-08-13),
         kein unaufgeloestes Suchwort. */
      if (/^\d{1,3}(?:°|grad)$/.test(token)) return false;
      return true;
    });
    if (modifiers.length) tokens = tokens.filter(function (token) { return token !== String(modifiers.length); });
    return unique(tokens);
  }

  function aliasMatch(normalized) {
    var priority = { starter:3000, driver:2900, transformer:2850, wago:2800, ofen:2700, kuehlschrank:2700, uvc:2600, uva:2600, uvb:2600, blacklight:2600, 'uv-general':2500 };
    var matches = [];
    ALIAS_RULES.forEach(function (rule) {
      rule.phrases.forEach(function (item) {
        if (!phraseIn(normalized, item)) return;
        var phrase = normalize(item);
        var score = (priority[rule.id] || 0) + phrase.split(' ').length * 100 + phrase.length;
        matches.push({ rule:rule, phrase:phrase, score:score });
      });
    });
    matches.sort(function (a,b) { return b.score-a.score; });
    return matches[0] || null;
  }

  function familyMatch(normalized, bases) {
    var best = null;
    FAMILY_RULES.forEach(function (rule) {
      var baseHit = rule.bases.some(function (base) { return bases.indexOf(base) !== -1; });
      if (bases.length && !baseHit) return;
      var phrase = rule.aliases.filter(function (item) { return phraseIn(normalized, item); }).sort(function (a,b) { return normalize(b).length - normalize(a).length; })[0] || '';
      var weight = baseHit ? 1000 + Math.max.apply(Math, rule.bases.map(function (base) { return String(base).length; })) : normalize(phrase).length;
      if ((baseHit || phrase) && (!best || weight > best.weight)) best = { rule:rule, weight:weight };
    });
    return best ? best.rule : null;
  }

  function handleItem(handle) { return handle && catalogByHandle.get(handle); }
  function firstItem(handles) {
    for (var i = 0; i < handles.length; i += 1) { if (catalogByHandle.has(handles[i])) return catalogByHandle.get(handles[i]); }
    return null;
  }

  function displayBase(base) {
    var labels = { gu53:'GU5.3', gy635:'GY6.35', g24d:'G24d', g24q:'G24q', gx24d:'GX24d', gx24q:'GX24q', gr10q:'GR10q', gr8:'GR8', b22d:'B22d', ba15d:'BA15d', b15d:'B15d', r7s:'R7s', g10q:'G10q' };
    return labels[base] || String(base || '').toUpperCase();
  }

  function categoryNote(candidate) {
    var parts = [];
    if (candidate.bases.length) parts.push(candidate.bases.map(displayBase).join(' · '));
    if (candidate.technology) parts.push(candidate.technology === 'fluorescent' ? 'Leuchtstoff' : candidate.technology.toUpperCase());
    return parts.join(' · ');
  }

  function categoryCard(candidate, url, note) {
    return { title:candidate.title, url:preservePreview(url || candidate.url), note:note || categoryNote(candidate), count:candidate.count, image:candidate.image || '' };
  }

  function dedupe(list, keyFn) {
    var seen = new Set();
    return list.filter(function (item) {
      if (!item) return false;
      var key = keyFn(item);
      if (!key || seen.has(key)) return false;
      seen.add(key); return true;
    });
  }

  function brandSpecificHandle(familyId, brand, technology) {
    var map = {
      'gu10|osram|led':'osram-reflektor-gu10', 'gu10|philips|led':'philips-reflektor-gu10',
      'gu53|osram|led':'osram-reflektor-gu53', 'gu53|philips|led':'philips-reflektor-gu53',
      'e14|osram|led':'osram-e14-led', 'e14|philips|led':'philips-e14-led',
      'e27|osram|led':'osram-e27-led', 'e27|philips|led':'philips-e27-led',
      't8|osram|led':'osram-led-roehren', 't8|osram-ledvance|led':'osram-led-roehren', 't8|philips|led':'philips-led-roehren',


      't5|osram|fluorescent':'osram-t5-leuchtstoffroehren', 't5|osram-ledvance|fluorescent':'osram-t5-leuchtstoffroehren', 't5|philips|fluorescent':'philips-t5-leuchtstoffroehren',
      't8|osram|fluorescent':'osram-t8-leuchtstoffroehren', 't8|osram-ledvance|fluorescent':'osram-t8-leuchtstoffroehren', 't8|philips|fluorescent':'philips-t8-leuchtstoffroehren'
    };
    return map[familyId + '|' + brand + '|' + technology] || '';
  }

  function familyTarget(rule, technology, brand) {
    var key = technology === 'led' ? 'led' : technology === 'halogen' ? 'halogen' : technology === 'fluorescent' ? 'fluorescent' : 'general';
    var specific = brandSpecificHandle(rule.id, brand, technology || (rule.id === 'gu10' || rule.id === 'gu53' || rule.id === 'e14' || rule.id === 'e27' ? 'led' : ''));
    if (specific && catalogByHandle.has(specific)) return catalogByHandle.get(specific);
    return firstItem([rule[key], rule.general, rule.led, rule.fluorescent, rule.halogen].filter(Boolean));
  }

  function shapeTarget(rule, technology, normalized) {
    if (['halogen','fluorescent','hid','incandescent'].indexOf(technology) !== -1 || (rule.id !== 'e14' && rule.id !== 'e27')) return null;
    if (/\b(?:backofen\w*|kuehlschrank\w*|naehmaschine\w*|salzlampe\w*|infrarot\w*|halolux)\b/.test(normalized)) return null;
    var prefix = rule.id + '-led-';
    var shapes = {stick:'stick', kerze:'kerzenlampen', tropfen:'tropfenlampen', globe:'globe-lampen', strahler:'strahler'};
    var keys = ['stick','kerze','tropfen','globe','edison','filament','strahler','gluehbirne'];
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (!hasWord(normalized, key)) continue;
      if (key === 'filament') return handleItem('led-' + rule.id + '-filament-leuchtmittel');
      if (key === 'edison' && rule.id === 'e27') return handleItem(prefix + 'edisonform');
      if (key === 'gluehbirne' && rule.id === 'e27' && technology === 'led') return handleItem(prefix + 'gluehbirnen');
      if (shapes[key]) return handleItem(prefix + shapes[key]);
    }
    return null;
  }

  function lengthTarget(rule, technology, length) {
    if (technology !== 'led' || !length) return null;
    var handle = '';
    if (rule.id === 't5') handle = ({549:'t5-led-roehren-549mm',849:'t5-led-roehren-849mm',1149:'t5-led-roehren-1149mm',1449:'t5-led-roehren-1449mm'})[length] || '';
    if (rule.id === 't8') handle = ({600:'t8-led-roehren-60-cm',900:'t8-led-roehren-90-cm',1200:'t8-led-roehren-120-cm',1500:'t8-led-roehren-150-cm'})[length] || '';
    return handleItem(handle);
  }

  function familyCategoryHandles(rule, technology, brand) {
    var handles = [];
    var specific = brandSpecificHandle(rule.id, brand, technology || 'led');
    if (specific) handles.push(specific);
    if (technology && rule[technology]) handles.push(rule[technology]);
    if (rule.general) handles.push(rule.general);
    ['led','fluorescent','halogen'].forEach(function (key) { if (rule[key]) handles.push(rule[key]); });
    if (rule.id === 't5' && technology === 'led') handles = ['t5-led-roehren','t5-led-roehren-549mm','t5-led-roehren-849mm','t5-led-roehren-1149mm','t5-led-roehren-1449mm'];
    if (rule.id === 't8' && technology === 'led') handles = ['t8-led-roehren','t8-led-roehren-60-cm','t8-led-roehren-90-cm','t8-led-roehren-120-cm','t8-led-roehren-150-cm'];
    if (rule.id === 'gu53') handles = technology === 'halogen'
      ? ['gu5-3-halogenlampen','gu5-3-leuchtmittel','gu5-3-led-leuchtmittel','osram-reflektor-gu53','philips-reflektor-gu53']
      : ['gu5-3-led-leuchtmittel','gu5-3-leuchtmittel','gu5-3-halogenlampen','osram-reflektor-gu53','philips-reflektor-gu53'];
    return unique(handles).map(handleItem).filter(Boolean);
  }

  function familySuggestions(rule, primary, technology, targetPairs) {
    var items = [];
    var categories = familyCategoryHandles(rule, technology, '');
    categories.forEach(function (candidate) {
      items.push({ label:candidate.title, url:preservePreview(candidate.url), note:categoryNote(candidate) });
    });
    if (primary && (primary.kind === 'lamp' || primary.technology || rule.id === 't5' || rule.id === 't8')) {
      /* FILTERS.code ebenfalls entfernen (2026-08-14): die Lichtfarb-Varianten
         ("warmweiss"/"4000 K"/"6500 K") wuerden sonst einen widersprechenden
         color_code-Filter aus der Query mitschleppen (827 + 4000 K = leer). */
      var basePairs = targetPairs.filter(function (pair) { return pair[0] !== FILTERS.kelvin && pair[0] !== FILTERS.code && pair[0] !== FILTERS.dimmable; });
      items.push({ label:primary.title + ' warmweiß', url:collectionUrl(primary.handle, basePairs.concat([[FILTERS.kelvin,['2700','3000']]])), note:'2700 K oder 3000 K' });
      items.push({ label:primary.title + ' 4000 K', url:collectionUrl(primary.handle, basePairs.concat([[FILTERS.kelvin,'4000']])), note:'neutralweiß' });
      items.push({ label:primary.title + ' 6500 K', url:collectionUrl(primary.handle, basePairs.concat([[FILTERS.kelvin,'6500']])), note:'tageslichtweiß' });
      var effectiveTechnology = technology || primary.technology || '';
      var generalDimmableFamily = ['gu10','gu53','gu4','g53','e14','e27','r7s','g4','g9','gy635'].indexOf(rule.id) !== -1;
      if (effectiveTechnology === 'led' || generalDimmableFamily) items.push({ label:primary.title + ' dimmbar', url:collectionUrl(primary.handle, basePairs.concat([[FILTERS.dimmable,'true']])), note:'nur dimmbare Artikel' });
      if (rule.id === 't5' || rule.id === 't8') { var repl = rule.id === 't5' ? '35' : '36'; items.push({ label:primary.title + ' ersetzt ' + repl + ' W', url:collectionUrl(primary.handle, basePairs.concat([[FILTERS.replaces,repl]])), note:'Ersatz für Leuchtstoffröhre' }); }
    }
    return dedupe(items, function (item) { return normalize(item.label) + '|' + item.url; }).slice(0,10);
  }

  function aliasTarget(alias, normalized, technology, brand) {
    var handles = alias.rule.handles.slice();
    if (alias.rule.id === 'compact-fluorescent') {
      if (brand === 'osram' || brand === 'osram-ledvance') handles = ['osram-kompaktleuchtstofflampen','kompaktleuchtstofflampen','led-ersatz-kompaktleuchtstofflampen'];
      else if (brand === 'philips') handles = ['philips-kompaktleuchtstofflampen','kompaktleuchtstofflampen','led-ersatz-kompaktleuchtstofflampen'];
      else if (technology === 'led') handles = ['led-ersatz-kompaktleuchtstofflampen','kompaktleuchtstofflampen'];
    }
    if (alias.rule.id === 'led-tube') {
      if (brand === 'osram' || brand === 'osram-ledvance') handles = ['osram-led-roehren','led-roehren','t8-led-roehren','t5-led-roehren'];
      else if (brand === 'philips') handles = ['philips-led-roehren','led-roehren','t8-led-roehren','t5-led-roehren'];
    }
    if (alias.rule.id === 'fluorescent-tube') {
      /* TECHNOLOGIE VOR FAMILIENWORT (Chris, 2026-08-10). Nennt die Anfrage LED
         ausdruecklich, ist die Technologie LED — auch wenn das Familienwort
         konventionell klingt. Bisher fehlte diese Stufe als einzige Alias-Regel:
         "LED Leuchtstoffroehre", "LED Leuchtstofflampe" und "LED Neonroehre"
         landeten auf /collections/leuchtstoffroehren, waehrend "LED Roehre",
         "LED Tube" und "LED Roehrenlampe" korrekt /collections/led-roehren
         erreichten (live gemessen 10.08.2026). Ursache: zwischen "led" und
         "roehre" steht ein Wort, deshalb greift die led-tube-Phrase nicht, und
         aliasTarget hat die erkannte Technologie hier nie ausgewertet.
         Ohne LED-Token bleibt jede konventionelle Zuordnung unveraendert. */
      if (technology === 'led') {
        if (brand === 'osram' || brand === 'osram-ledvance') handles = ['osram-led-roehren','led-roehren','t8-led-roehren','t5-led-roehren'];
        else if (brand === 'philips') handles = ['philips-led-roehren','led-roehren','t8-led-roehren','t5-led-roehren'];
        else handles = ['led-roehren','t8-led-roehren','t5-led-roehren','t9-led-roehren-ringform'];
      }
      else if (brand === 'osram' || brand === 'osram-ledvance') handles = ['osram-leuchtstoffroehren','osram-t8-leuchtstoffroehren','osram-t5-leuchtstoffroehren','leuchtstoffroehren'];
      else if (brand === 'philips') handles = ['philips-leuchtstoffroehren','philips-t8-leuchtstoffroehren','philips-t5-leuchtstoffroehren','leuchtstoffroehren'];
      else if (brand === 'sylvania') handles = ['sylvania-leuchtstoffroehren','leuchtstoffroehren'];
    }
    if (alias.rule.id === 'under-cabinet' && technology !== 'led') handles = ['unterbauleuchten','led-unterbauleuchten','lichtleisten'];
    if (alias.rule.id === 'bulb' && technology === 'led') handles = ['led-lampen','e27-led-gluehbirnen','e14-led-leuchtmittel'];
    if (alias.rule.id === 'feuchtraum' && technology !== 'led') handles = ['feuchtraumleuchten','led-feuchtraumleuchten'];
    if (alias.rule.id === 'battery') {
      if (phraseIn(normalized,'knopfzelle') || /\b(cr\d+|lr44|v23ga)\b/.test(normalized)) handles = ['knopfzellen','spezialbatterien','batterien'];
    }
    return { primary:firstItem(handles), candidates:handles.map(handleItem).filter(Boolean) };
  }

  function consumedByAlias(normalized, alias, family, brand, technology, modifiers) {
    var consumed = [];
    if (alias) alias.rule.phrases.forEach(function (phrase) { if (phraseIn(normalized, phrase)) consumed = consumed.concat(tokenize(phrase)); });
    if (family) family.aliases.forEach(function (phrase) { if (phraseIn(normalized, phrase)) consumed = consumed.concat(tokenize(phrase)); });
    if (brand) consumed = consumed.concat(tokenize(brand));
    if (technology) consumed.push(technology);
    if (modifiers.kelvin.length) consumed = consumed.concat(['warmweiss','neutralweiss','kaltweiss','tageslicht','k']);
    if (modifiers.length) consumed = consumed.concat(['mm','cm','m']);
    if (modifiers.dimmable !== null) consumed.push('dimmbar');
    if (modifiers.wattage || modifiers.replaces) consumed.push('watt');
    if (modifiers.lumen) consumed.push('lumen');
    if (modifiers.beam) consumed.push('grad');
    return new Set(consumed);
  }

  function unresolvedTokens(core, consumed, primary) {
    var generic = new Set(['lampe','roehre','leuchte','strahler','reflektor','batterie','fassung','led','halogen','leuchtstoff','fluorescent','neon','ladekabel','wallbox','klemme','steckdose','schalter','adapter','zubehoer','starter','vorschaltgeraet','trafo','treiber']);
    return core.filter(function (token) {
      return !generic.has(token) && !consumed.has(token) && !(primary && primary.tokenSet.has(token));
    });
  }

  function conflictingBase(queryBases, candidateBases) {
    if (!queryBases.length) return false;
    var aliases = { t8:'g13',g13:'t8',t5:'g5',g5:'t5',t9:'g10q',g10q:'t9' };
    var match = queryBases.some(function (base) {
      return candidateBases.indexOf(base) !== -1 || (aliases[base] && candidateBases.indexOf(aliases[base]) !== -1);
    });
    if (match) return false;


    return candidateBases.some(function (base) { return KNOWN_BASES.indexOf(base) !== -1 || /^t(?:5|8|9|12)$/.test(base); });
  }

  function scoreCandidate(candidate, context) {
    if (context.kind && candidate.kind && context.kind !== candidate.kind) {
      if (!((context.kind === 'lamp' && candidate.kind === 'fixture') || (context.kind === 'fixture' && candidate.kind === 'lamp'))) return -Infinity;
    }
    if (conflictingBase(context.bases, candidate.bases)) return -Infinity;
    if (context.brand && candidate.brand && candidate.brand !== context.brand) return -Infinity;
    if (context.brand && !candidate.brand) return -Infinity;
    if (context.technology && candidate.technology && candidate.technology !== context.technology) return -Infinity;

    var overlap = context.core.filter(function (token) { return candidate.tokenSet.has(token); });
    var required = context.core.filter(function (token) { return !['lampe','roehre','leuchte','strahler','reflektor','led','halogen','leuchtstoff'].includes(token); });
    if (required.length && !required.every(function (token) { return candidate.tokenSet.has(token); })) return -Infinity;
    if (!overlap.length && context.normalized !== candidate.titleNormalized && context.normalized !== normalize(candidate.handle)) return -Infinity;

    var score = 0;
    if (context.normalized === candidate.titleNormalized) score += 140;
    if (context.normalized === normalize(candidate.handle)) score += 130;
    if (candidate.titleNormalized.indexOf(context.normalized) === 0 && context.normalized.length >= 3) score += 45;
    if (candidate.titleNormalized.indexOf(context.normalized) !== -1 && context.normalized.length >= 4) score += 25;
    score += overlap.length * 14;
    if (context.core.length && overlap.length === context.core.length) score += 35;
    if (context.bases.length && !conflictingBase(context.bases, candidate.bases)) score += 35;
    if (context.technology && candidate.technology === context.technology) score += 25;
    else if (!context.technology && candidate.technology) score -= 6;
    if (context.brand && candidate.brand === context.brand) score += 30;
    if (context.kind && candidate.kind === context.kind) score += 14;
    score -= Math.max(0, candidate.tokens.length - context.core.length) * 1.2;
    score += Math.min(10, Math.log10(Math.max(1, candidate.count)) * 3);
    return score;
  }

  function getMatches(context) {
    return catalog.map(function (candidate) { return { candidate:candidate, score:scoreCandidate(candidate, context) }; })
      .filter(function (entry) { return Number.isFinite(entry.score); })
      .sort(function (a,b) {
        if (b.score !== a.score) return b.score-a.score;
        if (b.candidate.count !== a.candidate.count) return b.candidate.count-a.candidate.count;
        return a.candidate.title.localeCompare(b.candidate.title,'de');
      });
  }

  function genericSuggestions(primary, matches, targetPairs) {
    var items = [{ label:primary.title, url:collectionUrl(primary.handle,targetPairs), note:categoryNote(primary) || 'Direkt zur Kategorie' }];
    matches.slice(1,12).forEach(function (entry) { items.push({ label:entry.candidate.title, url:preservePreview(entry.candidate.url), note:categoryNote(entry.candidate) }); });
    var excluded = /(?:^|-)uv(?:-|$)|schwarzlicht|spezial|medizin|infrarot|entladung|natrium|quecksilber|metalldampf|scheinwerfer|fahrzeug|starter|vorschalt|trafo|treiber|batter|ladegeraet|zubehoer|adapter/.test(primary.handle);
    var lightRefinements = !excluded && (primary.kind === 'lamp' || primary.kind === 'fixture' || primary.technology);
    if (lightRefinements) {
      /* FILTERS.code ebenfalls entfernen (2026-08-14) — siehe familySuggestions. */
      var basePairs = targetPairs.filter(function (pair) { return pair[0] !== FILTERS.kelvin && pair[0] !== FILTERS.code && pair[0] !== FILTERS.dimmable; });
      items.push({label:primary.title+' warmweiß',url:collectionUrl(primary.handle,basePairs.concat([[FILTERS.kelvin,['2700','3000']]])),note:'2700 K oder 3000 K'});
      items.push({label:primary.title+' 4000 K',url:collectionUrl(primary.handle,basePairs.concat([[FILTERS.kelvin,'4000']])),note:'neutralweiß'});
      if (primary.technology === 'led' || /dimmbar/.test(primary.handle)) {
        items.push({label:primary.title+' dimmbar',url:collectionUrl(primary.handle,basePairs.concat([[FILTERS.dimmable,'true']])),note:'nur dimmbare Artikel'});
      }
    }
    return dedupe(items,function(item){return normalize(item.label)+'|'+item.url;}).slice(0,10);
  }

  function resolve(raw) {
    var query = String(raw || '').trim();
    var normalized = normalize(query);
    var result = { version:VERSION, query:query, normalized:normalized, mode:'native', reason:'fallback', targetUrl:'', targetLabel:'', categories:[], suggestions:[], nativeUrl:nativeSearchUrl(query), unresolved:[] };
    if (!query) { result.mode='empty'; result.reason='empty'; return result; }
    if (identifierQuery(query)) { result.mode='exact'; result.reason='sku-ean-model'; return result; }

    var exactCollection = catalog.find(function (item) {
      return strictNormalize(query) === strictNormalize(item.title) || strictNormalize(query) === strictNormalize(item.handle);
    });
    if (exactCollection) {
      result.mode='route'; result.reason='exact-collection';
      result.targetUrl=collectionUrl(exactCollection.handle,[]); result.targetLabel=exactCollection.title;
      result.categories=[categoryCard(exactCollection)];
      result.suggestions=genericSuggestions(exactCollection,[],[]);
      return result;
    }

    var brand = detectBrand(normalized);
    var modifiers = parseModifiers(normalized);
    var bases = extractBases(normalized);
    var technology = detectTechnology(normalized);
    var kind = detectKind(normalized);
    var core = coreTokens(normalized,brand,modifiers);
    var family = familyMatch(normalized,bases);
    var alias = aliasMatch(normalized);

    if (alias && alias.rule.id === 'vehicle-halogen' && technology === 'led') {
      result.reason='vehicle-led-fallback';
      return result;
    }

    if (kind === 'accessory' && bases.length && !alias) {
      result.reason='precise-accessory-fallback';
      return result;
    }

    var aliasBeforeTube = alias && ['uv-general','uvc','uva','uvb','blacklight','starter','driver','transformer','wago'].indexOf(alias.rule.id) !== -1;
    if (family && (family.id === 't5' || family.id === 't8') && !technology && !aliasBeforeTube) {
      var ledItem = handleItem(family.led);
      var flItem = handleItem(family.fluorescent);
      result.mode='ambiguous'; result.reason='tube-technology-missing';
      result.categories=[ledItem,flItem].filter(Boolean).map(function(item){return categoryCard(item);});
      result.suggestions=result.categories.map(function(item){return {label:item.title,url:item.url,note:item.note};});
      return result;
    }

    /* Erkannte Ersatzleistung ohne Technologiewort gehoert zur LED-Collection,
       in der specs.replaces_wattage gepflegt ist. Mehrdeutige Einzelwattangaben
       haben kein replaces und behalten ihre bisherige Behandlung. */
    if (family && family.led && !technology && modifiers.replaces) technology = 'led';

    var primary = null;
    var candidateList = [];
    var reason = '';
    if (family && !aliasBeforeTube) {
      primary = shapeTarget(family,technology,normalized) || lengthTarget(family,technology,modifiers.length) || familyTarget(family,technology,brand);
      candidateList = familyCategoryHandles(family,technology,brand);
      reason = 'family-rule';
    }
    if (!primary && alias) {
      var aliasResult = aliasTarget(alias,normalized,technology,brand);
      primary = aliasResult.primary; candidateList = aliasResult.candidates; reason='alias-rule';
    }

    if (!primary && brand && kind) {
      var brandCollection = catalog.find(function (item) {
        return item.brand === brand && (item.titleNormalized === normalize(brand) || normalize(item.handle) === normalize(brand));
      });
      if (brandCollection) { primary=brandCollection; candidateList=[brandCollection]; reason='brand-category'; }
    }

    var context = {normalized:normalized,brand:brand,modifiers:modifiers,bases:bases,technology:technology,kind:kind,core:core};
    var matches = [];
    if (!primary) {
      matches = getMatches(context);
      if (matches.length) { primary=matches[0].candidate; candidateList=matches.slice(0,8).map(function(entry){return entry.candidate;}); reason='catalog-score'; }
    } else {
      matches = getMatches(context);
    }
    if (!primary) return result;

    // Only query evidence can resolve watt meaning; a default LED collection cannot.
    var ledEvidence = technology === 'led' || /\b(?:led|ledstar|parathom|substitube|corepro|master\s*led|classic\s*[abp]\s*\d+|filament\s*led|retrofit)\b/.test(normalized);
    var replacementEvidence = /\b(?:ersetzt|ersatz|statt|entspricht|anstelle)\b/.test(normalized);
    if (modifiers.wattAmbiguous && (ledEvidence || replacementEvidence)) {
      var w = Number(modifiers.wattage);
      var small = bases.some(function (base) { return ['e14','gu10','gu53','g9','b22d','g4','gy635'].indexOf(base) !== -1; });
      if ((small && w >= 20 && w <= 100) || (/\b(?:e27|filament|gluehbirne)\b/.test(normalized) && [25,35,40,50,60,75,100,120,150,200].indexOf(w) !== -1)) {
        modifiers.replaces = modifiers.wattage; modifiers.wattage = null;
        modifiers.wattAmbiguous = false; modifiers.wattModus = 'replaces';
        modifiers.replacesListe = replacesListe(w) || [wattFilterWert(w)];
      }
    }
    var skipLength = /^t[58]-led-roehren-(?:\d+-cm|\d+mm)$/.test(primary.handle);
    var targetPairs = modifierPairs(modifiers,primary.kind || kind,primary.technology || technology,skipLength);
    if (brand && !primary.brand) {
      var vendors = vendorValues(brand);


      if (vendors.length) targetPairs.push([FILTERS.vendor,vendors]);
    }
    var consumed = consumedByAlias(normalized,alias,family,brand,technology,modifiers);
    if (family && shapeTarget(family,technology,normalized) === primary) {
      ['stick','kerze','tropfen','globe','edison','filament','strahler','gluehbirne'].forEach(function (shape) {
        if (hasWord(normalized, shape) && shapeTarget(family,technology,shape) === primary) consumed.add(shape);
      });
    }
    result.unresolved = unresolvedTokens(core,consumed,primary);
    if (family && shapeTarget(family,technology,normalized) === primary) {
      ['stick','kerze','tropfen','globe','edison','filament','strahler','gluehbirne'].forEach(function (shape) {
        if (hasWord(normalized, shape) && shapeTarget(family,technology,shape) !== primary
            && !primary.tokenSet.has(shape) && result.unresolved.indexOf(shape) === -1) result.unresolved.push(shape);
      });
    }

    result.categories = dedupe(candidateList.map(function(item){return categoryCard(item);}),function(item){return item.url.split('?')[0];}).slice(0,7);
    if (!result.categories.length) result.categories=[categoryCard(primary)];
    var suggestionMatches = alias ? candidateList.filter(Boolean).map(function (item) { return { candidate:item, score:999 }; }) : matches;
    result.suggestions = family && !aliasBeforeTube ? familySuggestions(family,primary,technology,targetPairs) : genericSuggestions(primary,suggestionMatches,targetPairs);

    if (modifiers.wattAmbiguous && modifiers.wattage) {
      result.mode='ambiguous'; result.reason='watt-meaning-ambiguous';
      return result;
    }
    if (alias && alias.rule.ambiguous) {
      result.mode='ambiguous'; result.reason='alias-ambiguous';
      return result;
    }
    if (result.unresolved.length) {
      result.mode='ambiguous'; result.reason='unresolved-query-tokens';
      return result;
    }

    var targetUrl = collectionUrl(primary.handle,targetPairs);
    var highConfidence = reason === 'family-rule' || reason === 'alias-rule' || reason === 'brand-category';
    if (!highConfidence && matches.length) {
      var second=matches[1];
      highConfidence = matches[0].score>=90 || !second || matches[0].score-second.score>=10 || normalized===primary.titleNormalized || normalized===normalize(primary.handle);
    }
    if (highConfidence) {
      result.mode='route'; result.reason=reason; result.targetUrl=targetUrl; result.targetLabel=primary.title;
    } else {
      result.mode='ambiguous'; result.reason='multiple-category-matches';
    }
    return result;
  }

  function icon(kind) {
    if (kind==='search') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M16 16l5 5"/></svg>';
    if (kind==='category') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="3" y="4" width="8" height="7" rx="1"/><rect x="13" y="4" width="8" height="7" rx="1"/><rect x="3" y="13" width="8" height="7" rx="1"/><rect x="13" y="13" width="8" height="7" rx="1"/></svg>';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  }

  function panelMarkup(result) {
    var suggestions=dedupe(result.suggestions,function(item){return normalize(item.label)+'|'+item.url;}).slice(0,10);
    var categories=dedupe(result.categories,function(item){return item.url.split('?')[0];}).slice(0,7);
    var left=suggestions.length?'<section class="lmm-intent-panel__col"><p class="lmm-intent-panel__eyebrow">Suchvorschläge</p><ul class="predictive-search-results__list lmm-intent-suggestions list-unstyled">'+suggestions.map(function(item){return '<li class="predictive-search-results__card lmm-intent-suggestion" ref="resultsItems[]" role="option"><a class="lmm-intent-suggestion__link" href="'+escapeHtml(item.url)+'" data-lmm-intent-link><span class="lmm-intent-suggestion__icon">'+icon('search')+'</span><span class="lmm-intent-suggestion__copy"><strong>'+escapeHtml(item.label)+'</strong><small>'+escapeHtml(item.note||'')+'</small></span><span class="lmm-intent-suggestion__arrow">'+icon('arrow')+'</span></a></li>';}).join('')+'</ul></section>':'';
    var right=categories.length?'<section class="lmm-intent-panel__col"><p class="lmm-intent-panel__eyebrow">Passende Kategorien</p><ul class="predictive-search-results__list lmm-intent-categories list-unstyled">'+categories.map(function(item){var media=item.image?'<img src="'+escapeHtml(item.image)+'" alt="" width="64" height="64" loading="lazy">':'<span class="lmm-intent-category__placeholder">'+icon('category')+'</span>';var count=item.count>0?'<span class="lmm-intent-category__count">'+Number(item.count).toLocaleString('de-DE')+' Artikel</span>':'';return '<li class="predictive-search-results__card lmm-intent-category" ref="resultsItems[]" role="option"><a class="lmm-intent-category__link" href="'+escapeHtml(item.url)+'" data-lmm-intent-link><span class="lmm-intent-category__media">'+media+'</span><span class="lmm-intent-category__copy"><strong>'+escapeHtml(item.title)+'</strong><small>'+escapeHtml(item.note||'')+'</small>'+count+'</span><span class="lmm-intent-category__arrow">'+icon('arrow')+'</span></a></li>';}).join('')+'</ul></section>':'';
    return '<div class="lmm-intent-panel" data-lmm-intent-panel data-lmm-catalog-panel><div class="lmm-intent-panel__head"><div><span class="lmm-intent-panel__badge">Geführte Suche</span><strong>Passende Suchwege</strong></div><p>'+(result.mode==='ambiguous'?'Wählen Sie die fachlich passende Kategorie.':'Erkannte Merkmale werden als Filter gesetzt.')+'</p></div><div class="lmm-intent-panel__grid">'+left+right+'</div></div>';
  }

  function inputForBox(box) {
    var component=box.closest('predictive-search-component');
    return (component&&component.querySelector('input[name="q"]'))||document.querySelector('.lmmh-search__form input[name="q"], input[name="q"]');
  }

  function setNativeVisible(box,visible) {
    /* Nur die Leermeldung togglen. Produkt-/Kategorien-Panes verwaltet das Layout-Skript
       (lmm-bestseller-sort, integrate); hidden auf .lmm-predictive__sec--cats kollabiert
       die rechte Spalte dauerhaft, weil dessen Observer Attribut-Änderungen nicht sieht. */
    box.querySelectorAll('.lmm-predictive__none').forEach(function(element){if(visible)element.removeAttribute('hidden');else element.setAttribute('hidden','');});
  }

  function closeEmpty(box) {
    var panel=box.closest('.lmm-predictive__panel')||box.parentElement;
    box.querySelectorAll('[data-lmm-intent-panel]').forEach(function(element){element.remove();});
    setNativeVisible(box,false);
    if(panel)panel.setAttribute('hidden','');
    delete box.dataset.lmmIntentQuery; delete box.dataset.lmmIntentActive;
  }

  function enhance(box) {
    if(!(box instanceof HTMLElement))return;
    var input=inputForBox(box),query=input?input.value.trim():'';
    if(!query){closeEmpty(box);return;}
    var panel=box.closest('.lmm-predictive__panel')||box.parentElement;if(panel)panel.removeAttribute('hidden');
    var old=box.querySelector('[data-lmm-catalog-panel]');if(box.dataset.lmmIntentQuery===query&&old)return;
    box.querySelectorAll('[data-lmm-intent-panel]').forEach(function(element){element.remove();});box.dataset.lmmIntentQuery=query;
    var result=resolve(query);
    if(result.mode==='route'||result.mode==='ambiguous'){
      var host=box.querySelector('.lmm-predictive__inner')||box.firstElementChild||box,wrapper=document.createElement('div');wrapper.innerHTML=panelMarkup(result);host.prepend(wrapper.firstElementChild);setNativeVisible(box,false);box.dataset.lmmIntentActive=result.mode;
    }else{setNativeVisible(box,true);delete box.dataset.lmmIntentActive;}
  }

  function removeNoise(root) {
    var scope=root&&root.querySelectorAll?root:document;
    scope.querySelectorAll('.td-count,.lmm-intent-panel__footer,.lmm-intent-panel__primary').forEach(function(element){element.remove();});
    scope.querySelectorAll('.lmm-cattree details.cat-grp').forEach(function(details){var rootLink=details.querySelector(':scope > summary a[href*="/collections/led-roehren"]'),list=details.querySelector(':scope > .cat-kids');if(!rootLink||!list)return;Array.from(list.children).forEach(function(item){var link=item.querySelector('a[href*="/collections/led-roehren"]');if(link&&normalize(link.textContent).indexOf('uebersicht')!==-1)item.remove();});});
  }

  function enhanceAll(){clearTimeout(timer);timer=window.setTimeout(function(){removeNoise(document);document.querySelectorAll('[ref="predictiveSearchResults"], .lmm-predictive__results').forEach(enhance);},0);}

  function onSubmit(event){var form=event.target;if(!(form instanceof HTMLFormElement)||!form.matches('form[role="search"], .lmmh-search__form'))return;var input=form.querySelector('input[name="q"]'),result=input&&resolve(input.value);if(result&&result.mode==='route'&&result.targetUrl){event.preventDefault();event.stopImmediatePropagation();location.assign(result.targetUrl);}}


  /* --- Einmal-Navigation (2026-07-28) --------------------------------------
     Vom Absenden bis zum fachlichen Endziel genau EINE Dokumentnavigation.
     Bisher: War die Collection-Registry beim Absenden noch nicht ausgefuehrt --
     sie kommt seit 2026-07-26 als lazy geladenes Asset (lmm-shop-data.js) --,
     lieferte resolve() kein Route-Ziel. Das Formular ging dann nativ auf
     /search?type=product&q=... und der Intent-Router der Suchseite schickte den
     Nutzer per location.replace ein zweites Mal weiter: zwei vollstaendige
     Dokumentladungen fuer einen einzigen Suchvorgang (gemessen bei schneller
     Eingabe/Einfuegen).
     Jetzt: Steht die Registry noch aus, wird genau einmal auf die ohnehin
     laufende Ladung gewartet (gemeinsame Promise, keine kuenstliche
     Verzoegerung), danach genau einmal navigiert. Faellt die Registry aus oder
     antwortet sie nicht innerhalb der Sicherheitsgrenze, wird das Formular
     regulaer nativ abgeschickt -- identische Ziel-URL wie bisher.
     Die fachliche Zielbestimmung bleibt unveraendert: sie kommt weiterhin
     ausschliesslich aus resolve() beziehungsweise nativeSearchUrl(). */
  var NAV_GRENZE_MS = 900;      /* Obergrenze, kein Taktgeber */
  var registryWartet = null;    /* dieselbe Promise fuer alle Ausloeser */
  var navigiertBereits = false; /* Entprellung: exakt eine Navigation */
  var letztesZiel = '';         /* zuletzt angefordertes Ziel */

  function katalogBereit(){ return catalog.length > 0; }

  /* Dezimalkomma -> Punkt (Chris 2026-09-17): "4,6w" und "4.6w" muessen
     dieselben Treffer liefern. Shopifys Tokenizer zerlegt "4,6w" in "4" + "6w"
     (Suggest-API: 6-W-Roehren und 4,6-W-Bodeneinbauleuchten) und haelt "4.6w"
     als Dezimalzahl zusammen (Suggest-API: Philips CorePro 4,6-50W) — live
     gemessen am 17.09.2026 ueber /search/suggest.json. Ersetzt wird NUR ein
     Komma mit 1-3 Ziffern davor und 1-2 Ziffern danach (Watt-/Ampere-Dezimale
     wie 4,6 / 12,5 / 0,5); Artikelnummernlisten ("1030008088,1030008089") und
     Tausendertrennung ("1,000") bleiben unberuehrt.
     EINZIGE Definition dieser Regel: predictive-search.js (Dropdown, Enter)
     und sections/lmm-search-intent-router (Auffangnetz fuer direkte Adressen)
     rufen window.LMMSearchIntent.dezimalNormalisieren und halten nur einen
     gleichlautenden Rueckfall fuer den Fall, dass die Engine fehlt. */
  var RE_DEZIMALKOMMA = /(^|[^0-9])([0-9]{1,3}),([0-9]{1,2})(?=[^0-9]|$)/g;
  function dezimalNormalisieren(wert){
    return String(wert == null ? '' : wert).replace(RE_DEZIMALKOMMA, '$1$2.$3');
  }

  /* LMM (2026-10-20, AUFGABE:20261020-14): Gezielte Feldsuche fuer reine 10-stellige
     LMM-Artikelnummern (variants.sku:) und 13-stellige EANs (variants.barcode:).
     Shopifys normale Freitextsuche verfehlt 2.535 von 11.116 aktiven Artikeln
     (1.434 per SKU, 1.706 per EAN), waehrend die Feldsuche 100 % exakt findet.
     Das sichtbare Suchfeld bleibt unveraendert (identAnzeige entfernt das Praefix). */
  var RE_FELD_PREFIX = /^\s*variants\.(?:sku|barcode):\s*/i;
  function identAnzeige(wert){
    return String(wert == null ? '' : wert).replace(RE_FELD_PREFIX, '');
  }
  function feldSuche(wert){
    var text = dezimalNormalisieren(wert);
    var getrimmt = String(text || '').trim();
    if (!getrimmt) return text;
    var kompakt = identAnzeige(getrimmt).replace(/[\s\-.\u2010-\u2015]/g, '');
    if (/^[0-9]{10}$/.test(kompakt)) return 'variants.sku:' + kompakt;
    if (/^[0-9]{13}$/.test(kompakt)) return 'variants.barcode:' + kompakt;
    return text;
  }

  function internesZiel(url){
    if (typeof url !== 'string' || url.charAt(0) !== '/' || url.charAt(1) === '/') return '';
    try {
      var ziel = new URL(url, location.origin);
      if (ziel.origin !== location.origin) return '';
      if (ziel.protocol !== 'http:' && ziel.protocol !== 'https:') return '';
      return ziel.pathname + ziel.search + ziel.hash;
    } catch (fehler) { return ''; }
  }

  function routenZiel(query){
    /* Chris Phase 5 (2026-08-04): Enter darf den Kunden nur noch bei einem
       reinen Kategorie-Intent aus der Produktsuche herausfuehren. Bei
       "Philips TUV 11W", "16W/840 G13" oder "1000113446" landete er bisher
       auf einer gefilterten Collection und sah die nativen Treffer nie.
       ERWEITERT 2026-08-13 (Chris Phase 7/17): Serienfamilie mit vollstaendig
       als Filter mitreisender Technik routet wieder ("Dulux L 36W") —
       zentrale Regel LMMRelevance.routingErlaubt, identisch mit Router und
       Dropdown. Fehlt die Engine, bleibt das Verhalten unveraendert. */
    var ergebnis;
    try { ergebnis = resolve(query); } catch (fehler) { return ''; }
    if (!ergebnis || ergebnis.mode !== 'route' || !ergebnis.targetUrl) return '';
    if (window.LMMRelevance) {
      var erlaubt = typeof window.LMMRelevance.routingErlaubt === 'function'
        ? window.LMMRelevance.routingErlaubt(query, ergebnis)
        : window.LMMRelevance.reinerKategorieIntent(query);
      if (!erlaubt) return '';
    }
    return intentMarke(internesZiel(ergebnis.targetUrl), query);
  }

  /* TUEV-13 Zero-Result-Fallback (Chris 2026-08-16): Nur eine VOM ROUTER
     erzeugte Filterkombination darf spaeter automatisch gelockert werden.
     Genau dieser Navigationsweg bekommt deshalb drei Marker mit:
       lmm_iq  urspruengliche Anfrage (fuer den sichtbaren Hinweis)
       lmm_is  Stufe der Fallback-Leiter, beim Start immer 0
       lmm_ik  Signatur ueber die gesetzten filter.*-Paare
     Die Signatur bindet den Marker an genau diese Filtermenge. Aendert der
     Kunde auf der Collection spaeter selbst einen Filter, passt sie nicht
     mehr und die Automatik bleibt aus — ein manuell leergefilterter Zustand
     wird nie zurueckgesetzt. Ohne filter.*-Parameter (exact-collection) und
     bei Fragmenten gibt es keinen Marker.
     Ausgewertet in assets/lmm-intent-fallback.js. */
  function intentSignatur(suchstring) {
    var paare = suchstring.split('&').filter(function (teil) {
      return teil.indexOf('filter.') === 0;
    }).sort();
    var text = paare.join('&');
    var hash = 5381;
    for (var i = 0; i < text.length; i++) {
      hash = ((hash << 5) - hash + text.charCodeAt(i)) | 0;
    }
    return (hash >>> 0).toString(36);
  }

  function intentMarke(pfad, query) {
    if (!pfad || pfad.indexOf('#') !== -1) return pfad;
    var trenner = pfad.indexOf('?');
    if (trenner === -1) return pfad;
    var suche = pfad.slice(trenner + 1);
    if (suche.indexOf('filter.') === -1) return pfad;
    return pfad + '&lmm_iq=' + encodeURIComponent(query)
      + '&lmm_is=0&lmm_ik=' + intentSignatur(suche);
  }

  function registryLadung(){
    if (registryWartet) return registryWartet;
    registryWartet = new Promise(function (fertig) {
      var offen = true;
      function schluss(){ if (!offen) return; offen = false; fertig(); }
      window.setTimeout(schluss, NAV_GRENZE_MS);
      var laden = (window.LMMShopData && typeof window.LMMShopData.load === 'function')
        ? window.LMMShopData.load() : null;
      if (!laden || typeof laden.then !== 'function') { schluss(); return; }
      laden.then(function(){
        try { initCatalog(); } catch (fehler) { /* unbrauchbare Registry -> nativ */ }
        schluss();
      }, schluss);
    });
    return registryWartet;
  }

  function navSperre(){
    navigiertBereits = true;
    /* Selbstheilung, falls die Navigation abgebrochen wird: das Suchfeld darf
       nicht dauerhaft blockiert bleiben. */
    window.setTimeout(function(){ navigiertBereits = false; }, 4000);
  }

  function nativAbsenden(form, query){
    if (navigiertBereits) return;
    letztesZiel = nativeSearchUrl(query);
    navSperre();
    /* form.submit() erzeugt exakt dieselbe URL wie bisher (das Formular fuehrt
       type=product als verstecktes Feld) und uebernimmt alle weiteren Felder. */
    if (form && typeof form.submit === 'function') { form.submit(); return; }
    location.assign(letztesZiel);
  }

  function einmalNavigieren(pfad){
    if (navigiertBereits) return;
    letztesZiel = pfad;
    navSperre();
    location.assign(pfad);
  }

  function sucheAusloesen(event, form, input){
    if (navigiertBereits) {
      /* Wiederholung (mehrfaches Enter, Doppelklick). Horizons component.js
         registriert den Capture-Delegator fuer on:keydown FRUEHER als diese
         Engine; predictive-search.js#onSearchKeyDown hat deshalb schon eine
         Navigation auf /search?q=... angestossen, bevor wir ueberhaupt an die
         Reihe kommen. Verhindern laesst sie sich nicht mehr, ueberholen schon:
         dasselbe Ziel erneut anfordern. Der Browser fuehrt weiterhin genau
         EINEN Dokumentabruf aus, naemlich den zuletzt angeforderten. */
      event.preventDefault(); event.stopImmediatePropagation();
      if (letztesZiel) location.assign(letztesZiel);
      return;
    }
    var query = input ? input.value : '';
    /* Dezimalkomma -> Punkt vor JEDER Navigation (Chris 2026-09-17). Der Wert
       wird ins Feld zurueckgeschrieben, damit auch das native Absenden
       (Suchen-Button, form.submit) die Punktform traegt; die Route-Erkennung
       liest beide Schreibweisen ohnehin gleich. */
    var dezimal = dezimalNormalisieren(query);
    if (dezimal !== query) { query = dezimal; if (input) input.value = dezimal; }
    var feld = feldSuche(query);
    if (feld !== String(query || '').trim()) {
      event.preventDefault(); event.stopImmediatePropagation();
      einmalNavigieren(nativeSearchUrl(feld));
      return;
    }
    if (katalogBereit()) {
      var pfad = routenZiel(query);
      if (!pfad) return;                        /* native Suche unveraendert */
      event.preventDefault(); event.stopImmediatePropagation();
      einmalNavigieren(pfad);
      return;
    }
    if (!String(query || '').trim()) return;    /* leere Eingabe bleibt nativ */
    if (!window.Promise) return;                /* ohne Promise: nativ wie bisher */
    event.preventDefault(); event.stopImmediatePropagation();
    registryLadung().then(function(){
      var pfad = routenZiel(query);
      if (pfad) einmalNavigieren(pfad); else nativAbsenden(form, query);
    }, function(){ nativAbsenden(form, query); });
  }

  function onSubmitEinmal(event){
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[role="search"], .lmmh-search__form')) return;
    sucheAusloesen(event, form, form.querySelector('input[name="q"]'));
  }

  function onKeyDown(event){
    if (event.key !== 'Enter' || event.isComposing) return;
    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    if (!(event.target instanceof HTMLInputElement) || event.target.name !== 'q') return;
    var form = event.target.closest('form');
    if (!form || !form.matches('form[role="search"], .lmmh-search__form')) return;
    if (form.querySelector('[aria-selected="true"] a[href]')) return; /* Vorschlag gewaehlt */
    sucheAusloesen(event, form, event.target);
  }

  var observedPredictiveComponents = window.WeakSet ? new WeakSet() : null;
  function observePredictiveComponents(){
    if(!window.MutationObserver||!observedPredictiveComponents)return;
    document.querySelectorAll('predictive-search-component').forEach(function(component){
      if(observedPredictiveComponents.has(component))return;
      observedPredictiveComponents.add(component);
      new MutationObserver(function(mutations){
        var relevant=mutations.some(function(mutation){return mutation.type==='childList'&&(mutation.addedNodes.length||mutation.removedNodes.length);});
        if(relevant)enhanceAll();
      }).observe(component,{childList:true,subtree:true});
    });
  }

  function boot(){
    initCatalog();
    // Seit 2026-07-26 wird die Registry lazy nachgeladen (statisches Asset statt Inline-JSON).
    // Beim Boot ist sie deshalb regulaer noch nicht da — nur warnen, wenn sie VORHANDEN,
    // aber unvollstaendig ist. Sonst haetten wir eine Falschmeldung auf jeder Seite.
    if(document.getElementById('lmm-search-catalog-data')&&catalog.length<250&&window.console)console.warn('[LMM Search] Collection-Registry unvollstaendig:',catalog.length);
    document.addEventListener('submit',onSubmitEinmal,true);document.addEventListener('keydown',onKeyDown,true);
    document.addEventListener('input',function(event){if(event.target instanceof HTMLInputElement&&event.target.name==='q'){observePredictiveComponents();enhanceAll();}},true);
    document.addEventListener('focusin',function(event){if(event.target instanceof HTMLInputElement&&event.target.name==='q'){observePredictiveComponents();enhanceAll();}},true);
    observePredictiveComponents();enhanceAll();document.dispatchEvent(new CustomEvent('lmm:search-intent-ready',{detail:{version:VERSION,collections:catalog.length}}));
  }

  window.LMMSearchIntent={
    version:VERSION,normalize:normalize,parseModifiers:parseModifiers,resolve:resolve,routeQuery:function(query,replace){var result=resolve(query);if(result.mode!=='route'||!result.targetUrl)return false;if(replace)location.replace(result.targetUrl);else location.assign(result.targetUrl);return true;},
    enhanceAll:enhanceAll,nativeSearchUrl:nativeSearchUrl,makeCollectionUrl:collectionUrl,rebuildCatalog:initCatalog,getCatalog:function(){return catalog.slice();},catalogSize:function(){return catalog.length;},health:function(){return{version:VERSION,collections:catalog.length,catalogwide:catalog.length>=250};},panelMarkup:panelMarkup,
    detectBrand:detectBrand,vendorValues:vendorValues,isIdentifierQuery:identifierQuery,filterKeys:FILTERS,
    dezimalNormalisieren:dezimalNormalisieren,feldSuche:feldSuche,identAnzeige:identAnzeige,dezimalStand:'2026.10.20-1'
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();

